<template>
  <div v-if="device" class="mt-2">
    <v-snackbar :top="y === 'top'" v-model="snackbar">
      {{text}}
      <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
    <v-snackbar :top="y === 'top'" v-model="errorSnackbar">
      {{text}}
      <v-btn color="red" class="white--text" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
    <v-toolbar flat color="white">
      <qrcode style="height: 60px" v-if="device.ponMac" :value="device.ponMac"  />
      <h2 class="grey--text px-2" v-if="device&&device.deviceMakeModel&&device.deviceMakeModel.deviceTypeId == 1 &&device.deviceMakeModel.deviceMake">
        <v-chip color="green white--text" v-if="onustatus.initiated && onustatus.isOnline">Online</v-chip>
        <v-chip color="red white--text" v-else-if="(onustatus.initiated && !onustatus.isOnline)">Offline</v-chip>
        <v-chip v-else-if="onustatus.initiated" color="blue" class="white--text"> <v-progress-circular
                          size="20"
                          indeterminate
                          color="white"
                        ></v-progress-circular></v-chip>
                        <v-chip color="red white--text" v-else>Offline</v-chip>

      </h2>
      <h2 class="grey--text px-2" v-else-if="device&&device.deviceMakeModel&&device.deviceMakeModel.deviceTypeId == 13">
        <v-chip v-if="oltstatus.isOnline&&oltstatus.initiated" color="light-green" class="white--text">Online</v-chip>
          <v-chip v-else-if="!oltstatus.isOnline&&oltstatus.initiated" color="red" class="white--text">Offline</v-chip>
          <v-chip v-else color="blue" class="white--text">Unknown</v-chip>
        
      </h2>
      <h2 v-else-if="device&&device.acsDevice">
        <v-chip v-if="device.isOnline" color="light-green" class="white--text">Online</v-chip>
        <v-chip v-else-if="device.isOnline==false" color="red" class="white--text">Offline</v-chip>

          <v-chip v-else color="blue" class="white--text">Unknown</v-chip>
      </h2>
      <h2 class="grey--text px-2">{{device.deviceMakeModel.deviceMake.name}} {{device.deviceMakeModel.name}}</h2>
      <v-spacer></v-spacer>
      

      <v-flex xs4 v-if="!device.isU2000&&onustatus.isOnline&&device.Handle_ID != null&&!device.acsDevice" class="text-xs-left">
        <span class="grey--text">Optic RSSI: {{onustatus.opticRssi}}</span>
        <br />
        <span class="grey--text">Rx Power: {{onustatus.rxPower}}</span>
      </v-flex>
      <v-flex xs6 v-else-if="device&&device.deviceMakeModel&&device.deviceMakeModel.deviceTypeId == 1&&device.isU2000" class="text-xs-left">
        <v-layout justify-right align-center>
          <v-flex xs6 v-if="onustatus.isOnline">
            <span class="grey--text">
          Online Since:
          <v-chip
            color="blue"
            small
            class="white--text"
          >{{formatDateTime(onustatus.uptime)}}</v-chip>
        </span>
          </v-flex>
        </v-layout>
        <span v-if="onustatus.isOnline" class="grey--text">Last Updated: {{formatDateTime(onustatus.lastUpdated)}}</span>
      </v-flex>
      <v-flex xs6 v-else-if="device&&device.deviceMakeModel&&device.deviceMakeModel.deviceTypeId == 13&&device.isU2000&&oltstatus.isOnline">
        <v-layout justify-left align-center>
          <v-flex xs3>
            <v-layout align-center justify-left>
        <v-icon large>speed</v-icon>
        <h3 class="grey--text font-weight-light">CPU: {{oltstatus.cpu}}%</h3>
            </v-layout>
          </v-flex>
          <v-flex xs3>
            <v-layout align-center justify-left>
        <v-icon large>memory</v-icon>
        <h3 class="grey--text font-weight-light">Memory: {{oltstatus.memory}}%</h3>
            </v-layout>
          </v-flex>
          <v-flex xs3>
            <v-layout align-center justify-left>
        <v-icon large>thermostat</v-icon>
        <h3 class="grey--text font-weight-light">{{oltstatus.temperature}} C</h3>
            </v-layout>
          </v-flex>
          <v-flex>
      <v-switch v-model="device.shareDeviceStatus" label="Share Device Status"></v-switch>
          </v-flex>
        </v-layout>
      </v-flex>
       <v-flex xs6 v-else-if="device&&device.deviceMakeModel&&device.deviceMakeModel.deviceTypeId == 13&&device.isU2000">
        <v-layout justify-left align-center>
          <v-flex xs3>
            <v-layout align-center justify-left>
        <v-icon large>speed</v-icon>
        <h3 class="grey--text font-weight-light">CPU: {{oltstatus.cpu}}%</h3>
            </v-layout>
          </v-flex>
          <v-flex xs3>
            <v-layout align-center justify-left>
        <v-icon large>memory</v-icon>
        <h3 class="grey--text font-weight-light">Memory: {{oltstatus.memory}}%</h3>
            </v-layout>
          </v-flex>
          <v-flex xs3>
            <v-layout align-center justify-left>
        <v-icon large>thermostat</v-icon>
        <h3 class="grey--text font-weight-light">{{oltstatus.temperature}} C</h3>
            </v-layout>
          </v-flex>
          <!-- <v-flex xs3>
            <v-layout align-center justify-left class="mt-2">
      <v-switch @change="updateShareStatus(device)" v-model="device.shareDeviceStatus" label="Share Status"></v-switch>
            </v-layout>
          </v-flex> -->
        </v-layout>
      </v-flex>
      <v-flex xs2 v-if="device.inStock">
        <v-chip v-if="!device.reserved" color="light-green" class="white--text">In Stock</v-chip>
        <v-chip v-else color="blue" class="white--text">Reserved</v-chip>

      </v-flex>
     
    </v-toolbar>
    <v-toolbar flat color="white" pt-5 v-if="device&&device.details&&onustatus.isOnline">
      <v-layout justify-left align-center >
          
          <v-flex xs3>
            <v-layout align-center justify-left>
        <v-icon large>power</v-icon>
        <h3 class="grey--text font-weight-light">{{device.details.OPTICSTXVOL}}mV</h3>
            </v-layout>
          </v-flex>
          <v-flex xs3>
            <v-layout align-center justify-left>
        <v-icon large>straighten</v-icon>
        <h3 class="grey--text font-weight-light ml-1" >Distance: {{device.details.ONTRANGING}}m</h3>
            </v-layout>
          </v-flex>
          <v-flex xs3>
            <v-layout align-center justify-left>
        <v-icon large>thermostat</v-icon>
        <h3 class="grey--text font-weight-light">{{device.details.OPTICSTXTEMP}} C</h3>
            </v-layout>
          </v-flex>
          <v-flex xs3>
            <v-layout align-center justify-left>
              <v-flex>
                <h3 class="grey--text">RX Optic RSSI: {{parseFloat(device.details.OPTICSRXPOWER)/100}}</h3>
                <h3 class="grey--text">TX Optic RSSI: {{parseFloat(device.details.OPTICSTXPOWER)/100}}</h3>
              </v-flex>
        <!-- <h3 class="grey--text font-weight-light">CPU: {{oltstatus.cpu}}%</h3> -->
            </v-layout>
          </v-flex>
         
        </v-layout>
    </v-toolbar>

    <v-divider></v-divider>

    <v-container fluid grid-list-xs >
     
      <v-layout row wrap>
        <v-flex grow d-flex style="max-width: 500px">
          <v-card class="rounded-card">
             <v-card-text>
            <h2 class="dark-grey--text">
              Device Information
              <v-btn v-if="!editingDevice" round class="primary" @click="editDeviceInfoItem()">
                <v-icon color="white">edit</v-icon>Edit
              </v-btn>
              <v-btn
                round
                class="red white--text"
                v-if="editingDevice"
                @click="editDeviceInfoItem()"
              >
                <v-icon color="white">cancel</v-icon>Cancel Edit
              </v-btn>
              <v-btn
                v-if="editingDevice"
                class="primary"
                round
                @click="saveDeviceInfoChanges()"
              >Save Info Changes</v-btn>
            </h2>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs12 sm12 md12 text-xs-left>
                  <v-layout justify-left align-center>
                    <v-flex xs6>
                      <h2 class="subheading grey--text font-weight-bold">System Name:</h2>
                    </v-flex>
                    <v-flex xs6 v-if="!editingDevice">
                      <h3 class="grey--text font-weight-light">{{device.systemName}}</h3>
                    </v-flex>
                    <v-flex xs6 v-else>
                      <v-text-field @change="logChange('systemName', null, 'System Name', device.systemName, 'updated')" v-model="device.systemName">{{device.systemName}}</v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-left align-center>
                    <v-flex xs6>
                      <h2 class="subheading grey--text font-weight-bold">Model:</h2>
                    </v-flex>
                    <v-flex xs6 v-if="!editingDevice">
                      <h3 class="grey--text font-weight-light">{{device.deviceMakeModel.deviceMake.name}} {{device.deviceMakeModel.name}}</h3>
                    </v-flex>
                    <v-flex xs6 v-else>
                     <v-select :items="deviceMakeModels" item-text="name" item-value="id" v-model="device.deviceMakeModel"></v-select>
                    </v-flex>
                  </v-layout>
                     <v-layout justify-left align-center v-if="device.note">
                    <v-flex xs6>
                      <h2 class="subheading grey--text font-weight-bold" >Note:</h2>
                    </v-flex>
                    <v-flex xs6>
                      <h3 class="grey--text font-weight-light" v-if="!editingDevice">{{device.note}}</h3>
                      <v-text-field v-else v-model="device.note"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-left align-center>
                    <v-flex xs6>
                      <h2 class="subheading grey--text font-weight-bold">Serial Number:</h2>
                    </v-flex>
                    <v-flex xs6 v-if="!editingDevice">
                      <h3 class="grey--text font-weight-light">{{device.serialNumber}}</h3>
                    </v-flex>
                    <v-flex xs6 v-else>
                      <v-text-field @change="logChange('serialNumber', null, 'Serial Number', device.serialNumber, 'updated')" v-model="device.serialNumber"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-left align-center>
                    <v-flex xs6>
                      <h2 class="subheading grey--text font-weight-bold">PON Mac/FSAN:</h2>
                    </v-flex>
                    <v-flex xs6 v-if="!editingDevice">
                      <h3 class="grey--text font-weight-light">{{device.ponMac}}</h3>
                    </v-flex>
                    <v-flex xs6 v-else>
                      <v-text-field @change="logChange('ponMac', null, 'PON Mac/FSAN', device.ponMac, 'updated')" v-model="device.ponMac"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-left align-center>
                    <v-flex xs6>
                      <h2 class="subheading grey--text font-weight-bold">IP Address:</h2>
                    </v-flex>
                    <v-flex xs6 v-if="!editingDevice">
                      <h3 class="grey--text font-weight-light">{{device.ipAddress}}</h3>
                    </v-flex>
                    <v-flex xs6 v-else>
                      <v-text-field @change="logChange('ipAddress', null, 'IP Address', device.ipAddress, 'updated')" v-model="device.ipAddress"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-left align-center v-if="device.frame!==null">
                    <v-flex xs6>
                      <h2 class="subheading grey--text font-weight-bold">Frame:</h2>
                    </v-flex>
                    <v-flex xs6>
                      <h3 class="grey--text font-weight-light">{{device.frame}}</h3>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-left align-center v-if="device.slot!==null">
                    <v-flex xs6>
                      <h2 class="subheading grey--text font-weight-bold">Slot:</h2>
                    </v-flex>
                    <v-flex xs6>
                      <h3 class="grey--text font-weight-light">{{device.slot}}</h3>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-left align-center v-if="device.port!==null">
                    <v-flex xs6>
                      <h2 class="subheading grey--text font-weight-bold">Port:</h2>
                    </v-flex>
                    <v-flex xs6>
                      <h3 class="grey--text font-weight-light">{{device.port}}</h3>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-left align-center v-if="device.ponId!==null">
                    <v-flex xs6>
                      <h2 class="subheading grey--text font-weight-bold">ONU ID:</h2>
                    </v-flex>
                    <v-flex xs6>
                      <h3 class="grey--text font-weight-light">{{device.ponId}}</h3>
                    </v-flex>
                  </v-layout>
                  <v-layout
                    justify-left
                    align-center
                    v-if="!device.inStock"
                  >
                    <v-flex xs6>
                      <h2 class="subheading grey--text font-weight-bold">Upstream Device:</h2>
                    </v-flex>
                    <v-flex xs6 v-if="device && device.upstreamDevice">
                      <h3 class="grey--text font-weight-light">
                        <v-icon v-if="editingDevice" @click="addUpstreamDeviceItem()">edit</v-icon>
                        {{device.upstreamDevice.deviceMakeModel.name}} || {{device.upstreamDevice.ipAddress}}
                      </h3>
                    </v-flex>
                    <v-flex xs4 v-else>
                      <v-btn small round class="primary" @click="addUpstreamDeviceItem()">
                        Add
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  
                   <v-layout justify-left align-center v-if="!editing&&device.stockWarehouseId||editing">
                    <v-flex xs6>
                      <h2 class="subheading grey--text font-weight-bold">Warehouse:</h2>
                    </v-flex>
                    <v-flex xs6 v-if="editingDevice">
                      <v-select :disabled="!editingDevice" clearble item-text="name" item-value="id" @change="validateWarehouseChange()" :items="warehouses" v-model="device.stockWarehouseId" label="Warehouse"></v-select>
                    </v-flex>
                    <v-flex xs6 v-else>
                      <h3 class="grey--text font-weight-light" v-if="device.stockWarehouse">{{device.stockWarehouse.name}}</h3>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-left align-center v-if="!device.inStock">
                    <v-flex xs6>
                      <h2 class="subheading grey--text font-weight-bold">Device Level:</h2>
                    </v-flex>
                    <v-flex xs6 v-if="editingDevice">
                      <v-select @change="logChange('devicelevel', null, 'Device Level', devicelevel, 'updated')" :items="deviceLevels" v-model="devicelevel" label="Select a Level"></v-select>
                    </v-flex>
                    <v-flex xs6 v-else>
                      <h3 class="grey--text font-weight-light">{{devicelevel}}</h3>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-left align-center v-if="!device.inStock">
                    <v-flex xs6>
                      <h2 class="subheading grey--text font-weight-bold">Located At:</h2>
                    </v-flex>
                    <v-flex xs6 v-if="device.location&&devicelevel==='End Location'">
                      <h3 class="grey--text font-weight-light">
                        <v-icon v-if="editingDevice" @click="editLocation()">edit</v-icon>
                        {{device.location.locationDescription}}
                      </h3>
                    </v-flex>
                    <v-flex
                      xs6
                      v-else-if="device.locationNetwork&&devicelevel==='Network'"
                    >
                      <h3 class="grey--text font-weight-light">
                        <v-icon v-if="editingDevice" @click="editNetwork()">edit</v-icon>
                        {{device.locationNetwork.name}}
                      </h3>
                    </v-flex>
                    <v-flex xs6 v-else-if="device.locationNode&&devicelevel==='Node'">
                      <h3 class="grey--text font-weight-light">
                        <v-icon v-if="editingDevice" @click="editNode()">edit</v-icon>
                        {{device.locationNode.name}}
                      </h3>
                    </v-flex>
                    <v-flex
                      xs6
                      v-else-if="device.switchingCentre&&devicelevel==='Switching Centre'"
                    >
                      <h3 class="grey--text font-weight-light">
                        <v-icon v-if="editingDevice" @click="editSwitchingCentre()">edit</v-icon>
                        {{device.switchingCentre.name}}
                      </h3>
                    </v-flex>
                    <v-flex xs2 v-else>
                      <v-btn
                        class="primary"
                        v-if="devicelevel==='End Location'"
                        round
                        @click="addLocationItem()"
                      >
                        <v-icon>add_circle_outline</v-icon>Add Location
                      </v-btn>
                      <v-btn
                        class="primary"
                        v-if="devicelevel==='Network'"
                        round
                        @click="addNetworkItem()"
                      >
                        <v-icon>add_circle_outline</v-icon>Add Network
                      </v-btn>
                      <v-btn
                        class="primary"
                        v-if="devicelevel==='Node'"
                        round
                        @click="addNodeItem()"
                      >
                        <v-icon>add_circle_outline</v-icon>Add Node
                      </v-btn>
                      <v-btn
                        class="primary"
                        v-if="devicelevel==='Switching Centre'"
                        round
                        @click="addSwitchingCentreItem()"
                      >
                        <v-icon>add_circle_outline</v-icon>Add Switching Centre
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          </v-card>
         
        </v-flex>

        <!-- Graphing needs attention -->

        <!-- <v-flex xs12 sm6 md6>
          <v-card-text>
            <h2 class="dark-grey--text">Graphs</h2>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs12 sm12 md12  text-xs-left>
                    <v-layout justify-left v-if="availablegraphs.length>0">
                        <v-flex xs8>
                            <h2 class="subheading grey--text font-weight-bold"> Available Graphs: </h2>
                        </v-flex>
                        <v-flex xs4>
                            <v-select :items="availablegraphs" item-text="desc" item-value="name" v-model="selectedGraph"></v-select>
                        </v-flex>
                        <v-flex>
                            <v-btn round class="primary" v-if="selectedGraph!==null" @click="getGraph()">Get Graph</v-btn>
                        </v-flex>
                    </v-layout>
                    <v-layout v-if="graphImage!==null">
                        <v-img contain :src="graphImage"/>
                    </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-flex>-->


      
        <!-- <v-flex v-if="online&&(device&&device.acsDevice)" xs6 sm4 md4>

          <v-card-text  >
            <h2 style="text-align:center" class="dark-grey--text">Speed Test   <v-btn v-if="device&&device.acsDevice&&!initialRun" round color="primary" @click="testSpeed()">Run</v-btn>
            
            <v-btn v-else-if="!device||!device.acsDevice" disabled round color="primary" >Unavailable</v-btn>
            <v-btn round @click="speedTestLogDialog=true" color="primary">View Log</v-btn>
            </h2>
            <v-layout v-if="device&&device.acsDevice&&initialRun" justify-center align-center wrap>         
           <v-btn  round color="primary" @click="testSpeed()">Run</v-btn>
            </v-layout>
            <v-layout v-if="!initialRun" justify-center align-center wrap>
              <v-flex xs12>
                <v-container grid-list-lg>
              <v-layout wrap>
                <v-card flat color="white" width="400px">
                  <v-card-text
                  >
                      <v-layout justify-center align-center>
                        <v-layout justify-center align-center v-if="visibleDownload">
                          <v-flex xs12>
                   <vue-loaders-ball-pulse scale="1"
                  
                  :key="visibleDownload"
                  color="#99cc33"
                ></vue-loaders-ball-pulse>                
                       <h4 class="grey--text" v-if="visibleDownload">Testing Download Speed</h4>
                       <br><br>
                          </v-flex>
                  </v-layout>
                                <v-flex justify-center v-else xs6 >
                        <VueSvgGauge
                          :start-angle="-110"
                          :end-angle="110"
                          :min="0"
                          :value="downloadSpeed"
                          :separator-step="25"
                          base-color="#d0cdcd"
                          :gauge-color="[{ offset: 0, color: '#347AB0'}, { offset: 100, color: '#8CDFAD'}]"
                          :scale-step="5"
                          :inner-radius="60"
                        />
                        </v-flex>
                         <v-layout justify-center align-center v-if="visibleUpload">
                        <v-flex xs12>
                   <vue-loaders-ball-pulse scale="1"                  
                  :key="visibleUpload"
                  color="#99cc33"
                ></vue-loaders-ball-pulse>
                       <h4 class="grey--text" v-if="visibleUpload">Testing Upload Speed</h4>
                           <br><br>
                          </v-flex>
                         </v-layout>
                                <v-flex justify-center v-else xs6 >
                        <VueSvgGauge
                          :start-angle="-110"
                          :end-angle="110"
                          :min="0"
                          :value="uploadSpeed"
                          :separator-step="25"
                          base-color="#d0cdcd"
                          :gauge-color="[{ offset: 0, color: '#347AB0'}, { offset: 100, color: '#8CDFAD'}]"
                          :scale-step="5"
                          :inner-radius="60"
                        />
                        </v-flex>
                         
                       </v-layout>
                      

  <v-layout justify-center align-center>
                          
                         <v-flex xs6 >
                          <span
                            class="grey--text font-weight-light"
                          >{{downloadSpeed}} Mbps <v-icon>arrow_downward</v-icon></span>
                        </v-flex>
                        
                          
                         <v-flex xs6>
                          <span
                            class="grey--text font-weight-light"
                          >{{uploadSpeed}} Mbps <v-icon>arrow_upward</v-icon></span>
                        </v-flex>
                      
                       
                        </v-layout>

                        <v-layout justify-center align-center>
                          
                         <v-layout style="text-align:center" v-if="showDownloadError">
                       <v-flex xs12>
                         <span style="text-align:center" class="grey--text font-weight-bold">An error occured while testing download speed</span>
                         </v-flex>
                         </v-layout>
                          
                       <v-layout style="text-align:center" v-if="showUploadError">
                         <v-flex xs12>
                         <span style="text-align:center" class="grey--text font-weight-bold">An error occured while testing upload speed</span>
                         </v-flex>
                       </v-layout>
                       
                        </v-layout>
                  </v-card-text>
                     
                </v-card>
              </v-layout>
              
             
            </v-container>
            
              </v-flex>
              
            </v-layout>
            
          </v-card-text>
        </v-flex> -->

    

        <v-flex
            grow
            mb-1
            style="max-width: 540px"
          >
           <v-card class="rounded-card mb-1" v-if="serviceAccounts&&serviceAccounts.length>0">
               
                <v-card-text>
                   <h3 class="dark-grey--text">
                  Service Accounts <v-chip>{{serviceAccounts.length}}</v-chip>
                  <!-- <v-icon color="primary" @click="createTicket('')">add_circle_outline</v-icon> -->
                </h3>
                <v-data-table dense :rows-per-page-items="4" :items="serviceAccounts" hide-headers style="cursor: pointer; font-size: 12px">
 <template v-slot:items="props">
   <td class="text-xs-center" @click="routeToServiceAccountSummary(props.item.id)">
     <v-chip style="cursor: pointer; font-size: 12px" small v-if="props.item.fnoActivationDate!==null&&new Date(props.item.fnoActivationDate)<new Date()&&props.item.isSuspended&&props.item.isActive" class="white--text" color="orange">Suspended</v-chip>
      <v-chip style="cursor: pointer; font-size: 12px" small v-else-if="props.item.fnoActivationDate!==null&&new Date(props.item.fnoActivationDate)<new Date()&&(new Date(props.item.fnoDeactivationDate)>new Date()||props.item.fnoDeactivationDate==null)" class="white--text" color="light-green">Active</v-chip>
      <v-chip style="cursor: pointer; font-size: 12px" small v-else-if="props.item.fnoActivationDate!==null&&props.item.fnoDeactivationDate!=null&&(new Date(props.item.fnoDeactivationDate)<new Date())" class="white--text" color="red">Inactive</v-chip>
      <v-chip style="cursor: pointer; font-size: 12px" small v-else-if="props.item.fnoActivationDate==null||new Date(props.item.fnoActivationDate)>new Date()" class="white--text" color="blue">Pending</v-chip>
   </td>
   <td class="text-xs-center" style="cursor: pointer; font-size: 12px" @click="routeToServiceAccountSummary(props.item.id)">{{props.item.circuitNumber}}</td>
   <td class="text-xs-center" style="cursor: pointer; font-size: 12px" @click="routeToServiceAccountSummary(props.item.id)">{{props.item.customerOrganisation.name}}</td>
   <td class="text-xs-center" @click="routeToServiceAccountSummary(props.item.id)">
     <v-layout wrap>
       <v-flex xs12>
         <v-layout align-center>
            <v-icon color="light-green">arrow_drop_down</v-icon>
                          {{props.item.packagesIsp.packagesFno.speedProfile.downloadMbps}}
         </v-layout>
        
       </v-flex>
       <v-flex xs12>
         <v-layout align-center>
         <v-icon color="red">arrow_drop_up</v-icon>
                           {{props.item.packagesIsp.packagesFno.speedProfile.uploadMbps}}
         </v-layout>
       </v-flex>
     </v-layout>
   </td>


<!-- 
   <td class="text-xs-center" @click="routeToTicketSummary(props.item.id)"><h3 class="grey--text">
                                    <v-chip
                                      small
                                      :class="`${props.item.currentStatus
                                        .replace(/\s/g, '')
                                        .toLowerCase()} white--text`"
                                      >{{ props.item.currentStatus }}</v-chip
                                    >
                                  </h3></td>
   <td class="text-xs-center" @click="routeToTicketSummary(props.item.id)">{{props.item.ticketCategoryItem.name}}</td>
   <td class="text-xs-center" @click="routeToTicketSummary(props.item.id)">{{formatDate(props.item.dueDate)}}</td> -->

 </template>
          </v-data-table>
                </v-card-text>
          </v-card>
          <v-card class="rounded-card">
               
                <v-card-text>
                   <h3 class="dark-grey--text">
                  Tickets <v-chip>{{devicetickets.length}}</v-chip>
                  <!-- <v-icon color="primary" @click="createTicket('')">add_circle_outline</v-icon> -->
                </h3>
                <v-data-table :rows-per-page-items="4" :items="devicetickets" hide-headers style="cursor: pointer">
 <template v-slot:items="props">
   <td class="text-xs-center" @click="routeToTicketSummary(props.item.id)">{{props.item.id}}</td>

   <td class="text-xs-center" @click="routeToTicketSummary(props.item.id)"><h3 class="grey--text">
                                    <v-chip
                                      small
                                      :class="`${props.item.currentStatus
                                        .replace(/\s/g, '')
                                        .toLowerCase()} white--text`"
                                      >{{ props.item.currentStatus }}</v-chip
                                    >
                                  </h3></td>
   <td class="text-xs-center" @click="routeToTicketSummary(props.item.id)">{{props.item.ticketCategoryItem.name}}</td>
   <td class="text-xs-center" @click="routeToTicketSummary(props.item.id)">{{formatDate(props.item.dueDate)}}</td>

 </template>
          </v-data-table>
                </v-card-text>
          </v-card>
          </v-flex>
    <v-flex shrink :key="loadingkey">
          <v-card class="rounded-card" key="">
            <v-card-text>
            <h2 class="dark-grey--text">Comments</h2>
            <v-text-field placeholder="Add Comment" v-model="comment" v-on:keydown.enter="addComment"></v-text-field>
            <v-card-text style="overflow-y: auto; height:300px; max-width: 500px; min-width: 300px">
               <v-timeline dense clipped v-if="devicecomments.length>0">
      <v-timeline-item
          v-for="comment in devicecomments"
          :key="comment.id"
          class="mb-3"
          color="grey"
          small
        >
          <v-layout justify-left  wrap>
            <v-flex xs7 text-xs-left>
               <span
                            class="grey--text font-weight-bold"
                          >{{comment.contact.name}} {{comment.contact.surname}}</span>
                          
            </v-flex>
            <v-flex xs5 text-xs-right>
               <span
                            class="grey--text font-weight-light"
                          >{{formatDateTime(comment.createdAt)}}</span>
            </v-flex>
            <v-flex xs12 text-xs-left>
              <span
                            class="text-xs-left grey--text font-weight-light word-break"
                            wrap
                          >{{comment.comments}}</span>
            </v-flex>
          </v-layout>
        </v-timeline-item>

            </v-timeline>
            <span v-else class="grey--text">No comments.</span>

            </v-card-text>
           
           
            
          </v-card-text>
          </v-card>
          
        </v-flex>
        <v-flex xs12 sm6 md6 d-flex v-if="deviceports&&deviceports.length>0">
          <v-card-text>
            <h2 class="dark-grey--text">Ports</h2>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs12 sm12 md12 text-xs-left>
                  <v-layout justify-left>
                    <v-flex xs8>
                      <h2 class="subheading grey--text font-weight-bold">Port:</h2>
                    </v-flex>
                    <v-flex xs4>
                      <v-autocomplete
                        v-model="selectedPort"
                        :items="deviceports"
                        hide-no-data
                        flat
                        color="primary"
                        item-text="description"
                        return-object
                        item-value="port_id"
                      ></v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-left v-if="selectedPort!==null">
                    <v-flex xs8>
                      <h2 class="subheading grey--text font-weight-bold">Name:</h2>
                    </v-flex>
                    <v-flex xs4>
                      <h3 class="grey--text font-weight-light">{{selectedPort.ifName}}</h3>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-left v-if="selectedPort!==null">
                    <v-flex xs8>
                      <h2 class="subheading grey--text font-weight-bold">Description:</h2>
                    </v-flex>
                    <v-flex xs4>
                      <h3 class="grey--text font-weight-light">{{selectedPort.description}}</h3>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-left v-if="selectedPort!==null">
                    <v-flex xs8>
                      <h2 class="subheading grey--text font-weight-bold">Port ID:</h2>
                    </v-flex>
                    <v-flex xs4>
                      <h3 class="grey--text font-weight-light">{{selectedPort.port_id}}</h3>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-left v-if="selectedPort!==null">
                    <v-flex xs8>
                      <h2 class="subheading grey--text font-weight-bold">Current In Rate:</h2>
                    </v-flex>
                    <v-flex xs4>
                      <h3 class="grey--text font-weight-light">{{selectedPort.inRate}}</h3>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-left v-if="selectedPort!==null">
                    <v-flex xs8>
                      <h2 class="subheading grey--text font-weight-bold">Current Out Rate:</h2>
                    </v-flex>
                    <v-flex xs4>
                      <h3 class="grey--text font-weight-light">{{selectedPort.outRate}}</h3>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-flex>

        <!-- <v-flex xs6 v-if="device.deviceMakeModel.deviceType.name==='OLT'">
            <v-btn class="primary" round @click="buildBridges()">Build Bridges</v-btn>
        </v-flex>-->
        <v-flex xs12 sm12 d-flex :key="loadingkey" v-if="device&&zhonebridges&&device.deviceMakeModel&&device.deviceMakeModel.deviceMake&&device.deviceMakeModel.deviceMake.name.includes('Zhone')">
          <v-card-text>
            <!-- <h2 class="dark-grey--text">Bridges <v-icon medium color="primary" @click="addBridgeModal()">add_circle</v-icon></h2> -->
            <!-- <h2 class="dark-grey--text">Connections <v-icon medium color="primary" @click="addBridgeModal()">add_circle</v-icon></h2>
             -->
            <h2 class="dark-grey--text">Connections </h2>

            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs3 text-xs-left v-for="bridge in zhonebridges" :key="bridge.id" my-2>
                  <v-card  mb-2 hover>
                    <v-layout align-center justify-center wrap>
                      <v-flex xs12>
                        <v-layout justify-left>
                          <v-flex xs8 mt-2 ml-3>
                            <h2 class="subheading grey--text font-weight-bold">Type:</h2>
                          </v-flex>
                          <v-flex xs4 mt-2 ml-3>
                            <h3
                              class="grey--text font-weight-light"
                            >{{tpTypeArray.find(x=>x.id===bridge.tpType).name}}</h3>
                          </v-flex>
                        </v-layout>
                        <v-layout justify-left>
                          <v-flex xs8 mt-2 ml-3>
                            <h2 class="subheading grey--text font-weight-bold">Ethernet Port:</h2>
                          </v-flex>
                          <v-flex xs4 mt-2 ml-3>
                            <h3 class="grey--text font-weight-light">{{bridge.tpIndex}}</h3>
                          </v-flex>
                        </v-layout>
                        <v-layout justify-left>
                          <v-flex xs8 mt-2 ml-3>
                            <h2 class="subheading grey--text font-weight-bold">UNI VLAN:</h2>
                          </v-flex>
                          <v-flex xs4 mt-2 ml-3>
                            <h3 class="grey--text font-weight-light">{{bridge.vlan}}</h3>
                          </v-flex>
                        </v-layout>
                        <v-layout justify-left>
                          <v-flex xs8 mt-2 ml-3>
                            <h2 class="subheading grey--text font-weight-bold">UNI SLAN:</h2>
                          </v-flex>
                          <v-flex xs4 mt-2 ml-3>
                            <h3 class="grey--text font-weight-light">{{bridge.slan}}</h3>
                          </v-flex>
                        </v-layout>
                        <v-layout justify-left>
                          <v-flex xs8 mt-2 ml-3>
                            <h2 class="subheading grey--text font-weight-bold">Inner VLAN:</h2>
                          </v-flex>
                          <v-flex xs4 mt-2 ml-3>
                            <h3 class="grey--text font-weight-light">{{bridge.vlanXlate}}</h3>
                          </v-flex>
                        </v-layout>
                        <v-layout justify-left>
                          <v-flex xs8 mt-2 ml-3>
                            <h2 class="subheading grey--text font-weight-bold">Outer VLAN:</h2>
                          </v-flex>
                          <v-flex xs4 mt-2 ml-3>
                            <h3 class="grey--text font-weight-light">{{bridge.slanXlate}}</h3>
                          </v-flex>
                        </v-layout>
                        <v-layout justify-left>
                          <v-flex xs8 mt-2 ml-3>
                            <h2 class="subheading grey--text font-weight-bold">Egress Index:</h2>
                          </v-flex>
                          <v-flex xs4 mt-2 ml-3>
                            <h3 class="grey--text font-weight-light">{{bridge.egressGroupIndex}}</h3>
                          </v-flex>
                        </v-layout>
                        <v-layout justify-left>
                          <v-flex xs8 mt-2 ml-3>
                            <h2 class="subheading grey--text font-weight-bold">Ingress Index:</h2>
                          </v-flex>
                          <v-flex xs4 mt-2 ml-3>
                            <h3 class="grey--text font-weight-light">{{bridge.groupIndex}}</h3>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex
                        xs4
                        v-if="$store.state.currentOrg.org.zhoneIntegration&&authAdmin($store.state.currentRoute)"
                      >
                        <v-layout justify-center>
                          <v-btn
                            round
                            color="red"
                            class="white--text"
                            @click="deleteBridgeItem(bridge)"
                          >
                            <v-icon color="white">delete</v-icon>
                          </v-btn>
                        </v-layout>
                      </v-flex>
                    </v-layout>

                    <!-- <v-card-actions>
                        <v-layout justify-center>
                            <v-btn round color="red" class="white--text" @click="deleteBridgeItem(bridge)"> <v-icon color="white">delete</v-icon></v-btn>
                        </v-layout>
                    </v-card-actions>-->
                  </v-card>
                </v-flex>
                <v-flex v-if="zhonebridges&&zhonebridges.length==0">
                  <v-layout justify-center>
                    <v-flex xs8 mt-2 ml-3>
                      <h2
                        class="subheading grey--text font-weight-bold"
                      >No Bridges listed against device.</h2>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-flex>

        <v-flex xs12 sm6 d-flex v-else-if="device&&(device.acsDevice||device.isU2000)&&acsprofiles&&device.deviceMakeModel.deviceTypeId == 1" :key="loadingkey">
          <v-card-text>
            <h2 class="dark-grey--text">
              Internet Profiles
              <!-- <v-icon medium color="primary" @click="addBridgeConnection()">add_circle</v-icon> -->
            </h2>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs12 sm6  text-xs-left v-for="hsi in acsprofiles" :key="hsi.id" my-2>
                  <v-card min-width="250px" hover >
                    <v-layout justify-left>
                      <v-flex xs8 mt-2 ml-3>
                        <h2 class="subheading grey--text font-weight-bold">Access Type:</h2>
                      </v-flex>
                      <v-flex xs3 mt-2 ml-3>
                        <h3 class="grey--text font-weight-light">{{hsi.access_type}}</h3>
                      </v-flex>
                      <v-flex xs1>
                      </v-flex>
                    </v-layout>
                    <v-layout justify-left>
                      <v-flex xs8 mt-2 ml-3>
                        <h2 class="subheading grey--text font-weight-bold">VLAN:</h2>
                      </v-flex>
                      <v-flex xs4 mt-2 ml-3>
                        <h3 class="grey--text font-weight-light">{{hsi.vlanXlate}}</h3>
                      </v-flex>
                    </v-layout>
                    <v-layout justify-left>
                      <v-flex xs8 mt-2 ml-3>
                        <h2 class="subheading grey--text font-weight-bold">Speed:</h2>
                      </v-flex>
                      <v-flex xs4 mt-2 ml-3>
                        <h3 class="grey--text font-weight-light">
                          <v-icon color="light-green">arrow_drop_up</v-icon>
                          {{hsi.downstreamRate}}
                          <v-icon color="red">arrow_drop_down</v-icon>
                          {{hsi.upstreamRate}}
                        </h3>
                      </v-flex>
                    </v-layout>

                    <v-layout justify-left v-if="hsi.access_type==='PPPoE'">
                      <v-flex xs8 mt-2 ml-3>
                        <h2 class="subheading grey--text font-weight-bold">PPPoE Username:</h2>
                      </v-flex>
                      <v-flex xs4 mt-2 ml-3>
                        <h3 class="grey--text font-weight-light">{{hsi.username}}</h3>
                      </v-flex>
                    </v-layout>
                    <v-layout justify-left v-if="hsi.access_type==='PPPoE'">
                      <v-flex xs8 mt-2 ml-3>
                        <h2 class="subheading grey--text font-weight-bold">PPPoE Password:</h2>
                      </v-flex>
                      <v-flex xs4 mt-2 ml-3>
                        <h3 class="grey--text font-weight-light">{{hsi.password}}</h3>
                      </v-flex>
                    </v-layout>
                    <v-layout justify-left>
                      <v-flex xs8 mt-2 ml-3>
                        <h2 class="subheading grey--text font-weight-bold">WAN Default Gateway:</h2>
                      </v-flex>
                      <v-flex xs4 mt-2 ml-3>
                        <h3 class="grey--text font-weight-light">{{hsi.wanDefaultGateway}}</h3>
                      </v-flex>
                    </v-layout>
                    <v-layout justify-left>
                      <v-flex xs8 mt-2 ml-3>
                        <h2 class="subheading grey--text font-weight-bold">WAN Static IP:</h2>
                      </v-flex>
                      <v-flex xs4 mt-2 ml-3>
                        <h3 class="grey--text font-weight-light">{{hsi.wanStaticIp}}</h3>
                      </v-flex>
                    </v-layout>
                    <v-layout justify-left>
                      <v-flex xs8 mt-2 ml-3>
                        <h2 class="subheading grey--text font-weight-bold">WAN Subnet:</h2>
                      </v-flex>
                      <v-flex xs4 mt-2 ml-3>
                        <h3 class="grey--text font-weight-light">{{hsi.wanSubnet}}</h3>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex xs2></v-flex>
                      <v-flex xs2 ml-4>
                        <h3 class="grey--text font-weight-light">Eth 1</h3>
                      </v-flex>
                      <v-flex xs2>
                        <h3 class="grey--text font-weight-light">Eth 2</h3>
                      </v-flex>
                      <v-flex xs2>
                        <h3 class="grey--text font-weight-light">Eth 3</h3>
                      </v-flex>
                      <v-flex xs2>
                        <h3 class="grey--text font-weight-light">Eth 4</h3>
                      </v-flex>
                    </v-layout>
                    <v-layout justify-left>
                      <v-flex xs2 ml-2>
                        <h2 class="subheading grey--text font-weight-bold">Ports</h2>
                      </v-flex>
                      <v-flex xs2 ml-4>
                        <v-icon v-if="hsi.port_1" color="light-green">check_circle</v-icon>
                        <v-icon v-else color="red">cancel</v-icon>
                      </v-flex>
                      <v-flex xs2>
                        <v-icon v-if="hsi.port_2" color="light-green">check_circle</v-icon>
                        <v-icon v-else color="red">cancel</v-icon>
                      </v-flex>
                      <v-flex xs2>
                        <v-icon v-if="hsi.port_3" color="light-green">check_circle</v-icon>
                        <v-icon v-else color="red">cancel</v-icon>
                      </v-flex>
                      <v-flex xs2>
                        <v-icon v-if="hsi.port_4" color="light-green">check_circle</v-icon>
                        <v-icon v-else color="red">cancel</v-icon>
                      </v-flex>
                    </v-layout>

                    <v-flex>
                      <v-layout justify-center >
                        <!-- <v-btn class="primary white--text" round @click="editHsiProfileItem(hsi)"><v-icon>edit</v-icon> Edit </v-btn> -->
                        <v-btn class="red white--text" round @click="removeU2000Bridge(hsi)">
                          <v-icon>delete</v-icon>Delete
                        </v-btn>
                      </v-layout>
                    </v-flex>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-flex>

        <v-flex xs12 sm6 v-if="device&&(device.acsDevice||device.isU2000)&&device.deviceMakeModel.isWifi&&device.deviceMakeModel.deviceTypeId == 1">
          <v-card-text>
            <h2 class="dark-grey--text">
              Wifi Profiles
              <!-- <v-icon medium color="primary" @click="addBridgeConnection()">add_circle</v-icon> -->
            </h2>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs12 sm6  text-xs-left v-for="wifi in wifiprofiles" :key="wifi.id" my-2>
                  <v-card min-width="250px" hover >
                    <v-layout justify-left align-center wrap>
                      <v-flex xs4 mx-1>
                        <h2 class="subheading grey--text font-weight-bold">SSID:</h2>
                      </v-flex>
                      <v-flex xs4 mx-1>
                        <h3 class="grey--text font-weight-light">{{wifi.ssid}}</h3>
                      </v-flex>
                      <v-flex xs4 mx-1>
                        <h2 class="subheading grey--text font-weight-bold">Frequency:</h2>
                      </v-flex>
                      <v-flex xs4 mx-1>
                        <h3 class="grey--text font-weight-light">{{wifi.frequencyBand}} GHz</h3>
                      </v-flex>
                      <v-flex xs4 mx-1>
                        <h2 class="subheading grey--text font-weight-bold">Enabled:</h2>
                      </v-flex>
                      <v-flex xs4 mx-1>
                        <v-icon v-if="wifi.enable" color="light-green">check_circle</v-icon>
                        <v-icon v-else color="red">cancel</v-icon>
                      </v-flex>
                      <v-flex xs4 mx-1>
                        <h2 class="subheading grey--text font-weight-bold">Channel:</h2>
                      </v-flex>
                      <v-flex xs4 mx-1>
                        <h2 class="subheading grey--text font-weight-light">{{wifi.channel}}</h2>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout justify-center wrap>
                          <v-btn small round color="primary" class="white--text" @click="editWifiProfileItem(wifi)"><v-icon>edit</v-icon></v-btn>
                          <v-btn small round color="red" class="white--text" @click="deleteWifiProfileItem(wifi)"><v-icon>delete</v-icon></v-btn>

                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-flex>
        <v-flex xs12>
          <v-card-text>
            <h2 class="dark-grey--text">
              Connected Devices <v-chip>{{linkeddevices.length}}</v-chip>
            </h2>
            <v-toolbar flat color="white">
              
              <v-text-field v-model="deviceSearch" label="Search"></v-text-field>
              <v-spacer></v-spacer>
            </v-toolbar>
          <v-data-table :items="linkeddevices" :headers="linkedDeviceHeaders" :search="deviceSearch" style="cursor: pointer">
                <template v-slot:items="props">
                  <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.systemName}}</td>
        <td
          @click="viewDeviceDetails(props.item)"
          class="text-xs-center"
          v-if="props.item.deviceMakeModel"
        >{{props.item.deviceMakeModel.deviceMake.name}} {{props.item.deviceMakeModel.name}}</td>
        <td @click="viewDeviceDetails(props.item)" class="text-xs-center" v-else></td>
        <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.ipAddress}}</td>
        <td
          @click="viewDeviceDetails(props.item)"
          class="text-xs-center"
        >{{props.item.serialNumber}}</td>
        <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.ponMac}}</td>
        <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.softwareVersion}}</td>
        <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.ponId}}</td>
        <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.frame}}</td>
        <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.slot}}</td>
        <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.port}}</td>
        <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.note}}</td>



        </template>
              </v-data-table>
          </v-card-text>
        </v-flex>

       
      </v-layout>
    </v-container>

    <!-- Modals -->
      <v-dialog v-model="speedTestLogDialog" max-width="750px" persistent>
      <v-card flat color="white">
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">Speed Test Log</h1>
          <v-spacer></v-spacer>
          <v-btn flat color="white" @click="speedTestLogDialog=false">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-data-table
      :headers="speedTestLogHeaders"
      class="elevation-1"
      :items="speedTestLog"
      :rows-per-page-items="[10,15,25]"
      item-key="id"
      :search="search"
      align-center
      style="cursor: pointer"
    >
      <template v-slot:items="props">
        <td  class="text-xs-center">{{formatDateTime(props.item.createdAt)}}</td>
        <td  class="text-xs-center">{{props.item.downloadSpeed}} Mbps <v-icon>arrow_downward</v-icon></td>
        <td  class="text-xs-center">{{props.item.uploadSpeed}} Mbps <v-icon>arrow_upward</v-icon></td>
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>


                    <!-- <v-layout v-if="speedTestLog.length>0" style="text-align:center" >
                         <v-flex xs12>
                      <v-card flat color="white" width="750px">
                  <v-card-text
                    v-if="speedTestLog && speedTestLog.length>0"
                    style="overflow-y: auto; max-height:400px"
                  >
                    <v-flex xs12 v-for="speedTest in speedTestLog" :key="speedTest.id">
                      <v-layout  align-center >
                        <v-flex>
                           <span
                            class="grey--text font-weight-light"
                          >{{formatDateTime(speedTest.createdAt)}} </span>
                         
                          <span
                            class="grey--text font-weight-bold"
                          >{{speedTest.downloadSpeed}} Mbps <v-icon>arrow_downward</v-icon></span>
                           <span
                            class="grey--text font-weight-bold"
                          >{{speedTest.uploadSpeed}} Mbps <v-icon>arrow_upward</v-icon></span>
                         
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-card-text>
                </v-card>
                           </v-flex>
                       </v-layout> -->
        </v-card-text>
      </v-card>
      </v-dialog>

      <v-dialog v-model="addBridgeConnectionModal" persistent width="750px">
        <v-card flat color="white">
          <v-toolbar flat color="primary">
            <h3 class="title white--text">Add Bridge Connection</h3>
            <v-spacer></v-spacer>
            <v-btn flat color="white" @click="addBridgeConnectionModal=false, item={}">X</v-btn>
          </v-toolbar>
          <v-card-text>
            <v-layout justify-center align-center wrap>
              <v-flex xs8 mx-1>
                <v-autocomplete ref="organisationbridgetemplates" v-on:blur="$refs['organisationbridgetemplates'].blur()" v-model="item.organisationBridgeTemplate" return-object :items="organisationbridgetemplates" label="Select a Bridge Template">
                  <template v-slot:selection="data">{{ data.item.customerOrganisation.name }} | {{data.item.innerVlan}} | {{data.item.outerVlan}} | {{data.item.deviceMake.name}}</template>
                  <template v-slot:item="data">
                    <template>
                      <v-list-tile-content>
                        <v-list-tile-title class="grey--text font-weight-bold">{{data.item.customerOrganisation.name}} <v-chip small dense color="primary" class="white--text">{{data.item.type}}</v-chip></v-list-tile-title>
                        <v-list-tile-sub-title>
                          <v-layout align-center class="grey--text font-weight-light" wrap>
                            <v-flex xs10 v-if="data.item.innerVlan"><span ><b> Inner VLAN:</b> {{data.item.innerVlan}}</span></v-flex>
                            <v-flex xs10 v-if="data.item.outerVlan"><span><b> Outer VLAN:</b> {{data.item.outerVlan}}</span></v-flex>
                          </v-layout>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                  </template>
                </v-autocomplete>
                
              </v-flex>
              <v-flex xs8 mx-1>
                <v-autocomplete ref="speedProfile" v-on:blur="$refs['speedProfile'].blur()" :items="speedprofiles" v-model="item.speedProfile" item-text="name" return-object label="Select a Speed Profile to Apply"></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-center align-center >
              <v-btn round class="white--text" color="primary" v-if="item.organisationBridgeTemplate" @click="createBridgeTicket(item)">Create Bridge</v-btn>
            <v-btn v-else round disabled>Create Bridge</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>

    <!-- HSI Add Modal -->
    <v-dialog v-model="addHsiProfileItem" max-width="750px" persistent>
      <v-card flat color="white">
        <v-toolbar flat class="primary">
          <!-- <h1 class="headline white--text">{{item.type}} HSI PROFILE</h1> -->
          <h1 class="headline white--text">HSI PROFILE</h1>

          <v-spacer></v-spacer>
          <v-btn flat color="white" @click="addHsiProfileItem=false, item={}">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout>
            <v-flex xs6 px-1>
            <v-autocomplete v-model="item.access_type" label="Access Type" :items="accessTypes"></v-autocomplete>
          </v-flex> 
           <v-flex xs6 px-1>
            <v-autocomplete v-if="item.type==='ADD'" v-model="item.customerOrganisationId" item-text="name" item-value="id" label="Associated Provider" :items="providers"></v-autocomplete>
            <v-autocomplete v-else disabled v-model="item.customerOrganisationId" item-text="name" item-value="id" label="Associated Provider" :items="providers"></v-autocomplete>
          </v-flex>
          </v-layout>
          
          <v-layout>
            <v-flex xs6 px-1 v-if="item.access_type==='PPPoE'||item.access_type==='PPPOE'">
              <v-text-field v-model="item.username" label="PPPoE Username"></v-text-field>
            </v-flex>
            <v-flex xs6 px-1 v-if="item.access_type==='PPPoE'||item.access_type==='PPPOE'">
              <v-text-field v-model="item.password" label="PPPoE Password"></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex xs6 px-1>
              <v-text-field
                type="number"
                min="0"
                v-model="item.upstreamRate"
                label="Upload Rate (Mbps)"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 px-1>
              <v-text-field
                type="number"
                min="0"
                v-model="item.downstreamRate"
                label="Download Rate (Mbps)"
              ></v-text-field>
            </v-flex>
          </v-layout> 


          <!-- <v-layout>
                    <v-flex xs6 v-if="item.type==='EDIT'&&addHsiProfileItem">
                    <v-text-field disabled v-model="item.speedProfile.downloadMbps" label="Download Rate (Mbps)" type="number"></v-text-field>
                </v-flex>
                <v-flex xs6 v-if="item.type==='EDIT'&&addHsiProfileItem">
                    <v-text-field disabled v-model="item.speedProfile.uploadMbps" label="Upload Rate (Mbps)" type="number"></v-text-field>
                </v-flex>
          </v-layout>-->


          <v-layout>
            <v-flex xs6 px-1>
              <v-text-field v-model="item.vlan" label="VLAN" type="number"></v-text-field>
            </v-flex>
            <v-flex xs6 px-1>
              <v-select v-model="item.ipv4or6" label="IPV Type" :items="ipv"></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6 px-1>
              <v-text-field v-model="item.wanStaticIp" label="WAN Static IP"></v-text-field>
            </v-flex>
            <v-flex xs6 px-1>
              <v-text-field v-model="item.wanSubnet" label="WAN Subnet"></v-text-field>
            </v-flex>
          </v-layout>

          <v-flex xs6 px-1>
            <v-text-field v-model="item.wanDefaultGateway" label="WAN Default Gateway"></v-text-field>
          </v-flex> 
           <v-flex xs12>
            <h3 class="grey--text">Ethernet Ports</h3>
          </v-flex>
          <v-layout>
            <v-flex>
              <v-switch
                v-model="item.port_1"
                label="Port 1"
                v-if="availablePorts.includes('port_1')"
              ></v-switch>
              <v-switch v-model="item.port_1" label="Port 1" disabled v-else></v-switch>
            </v-flex>
            <v-flex>
              <v-switch
                v-model="item.port_2"
                label="Port 2"
                v-if="availablePorts.includes('port_2')"
              ></v-switch>
              <v-switch v-model="item.port_2" label="Port 2" disabled v-else></v-switch>
            </v-flex>
            <v-flex>
              <v-switch
                v-model="item.port_3"
                label="Port 3"
                v-if="availablePorts.includes('port_3')"
              ></v-switch>
              <v-switch v-model="item.port_3" label="Port 3" disabled v-else></v-switch>
            </v-flex>
            <v-flex>
              <v-switch
                v-model="item.port_4"
                label="Port 4"
                v-if="availablePorts.includes('port_4')"
              ></v-switch>
              <v-switch v-model="item.port_4" label="Port 4" disabled v-else></v-switch>
            </v-flex>
          </v-layout>
          <v-flex xs12 v-if="item.type !=='ADD'">
            <h3 class="grey--text">
              Linked Wifi Profiles
              <v-icon
                color="primary"
                class="white--text"
                @click="addWifiProfileModal(item)"
              >add_circle_outline</v-icon>
            </h3>
          </v-flex>
          <v-layout v-if="item.type !=='ADD'&&device&&device.deviceMakeModel&&device.deviceMakeModel.isWifi&&item&&typeof(item.deviceWifis)!=='undefined'&&item.deviceWifis.length>0" :key="loadingkey">
            <v-flex xs6 px-1 v-for="wifi in item.deviceWifis" :key="wifi.id">
              <v-card>
                <v-card-text>
                  <v-layout class="grey--text">
                    <v-flex xs8>
                      <span class="font-weight-bold">SSID:</span>
                    </v-flex>
                    <v-flex xs4>
                      <span>{{wifi.ssid}}</span>
                    </v-flex>
                  </v-layout>
                  <v-layout class="grey--text">
                    <v-flex xs8>
                      <span class="font-weight-bold">Password:</span>
                    </v-flex>
                    <v-flex xs4>
                      <span>{{wifi.password}}</span>
                    </v-flex>
                  </v-layout>
                  <v-layout class="grey--text">
                    <v-flex xs8>
                      <span class="font-weight-bold">Frequency:</span>
                    </v-flex>
                    <v-flex xs4>
                      <span>{{wifi.frequencyBand}}Ghz</span>
                    </v-flex>
                  </v-layout>
                  <v-layout class="grey--text">
                    <v-flex xs8>
                      <span class="font-weight-bold">Channel:</span>
                    </v-flex>
                    <v-flex xs4>
                      <span>{{wifi.channel}}</span>
                    </v-flex>
                  </v-layout>
                  <v-layout class="grey--text">
                    <v-flex xs8>
                      <span class="font-weight-bold">Enabled:</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-icon v-if="wifi.enable" color="success">check_circle_outline</v-icon>
                      <v-icon v-else color="red">cancel</v-icon>
                    </v-flex>
                  </v-layout>
                  <v-layout class="grey--text">
                    <v-flex xs8>
                      <span class="font-weight-bold">Hidden:</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-icon v-if="wifi.hidden" color="success">check_circle_outline</v-icon>
                      <v-icon v-else color="red">cancel</v-icon>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-center>
                      <v-btn v-if="authUpdate($store.state.currentRoute)" color="primary" round class="white--text" @click="editWifiProfileItem(wifi)">Edit</v-btn>
                    <v-btn
                    v-if="authDelete($store.state.currentRoute)"
                      round
                      color="red"
                      class="white--text"
                      @click="deleteWifiProfileItem(wifi)"
                    >Delete</v-btn>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
           <v-layout justify-center v-else-if="item.type !=='ADD'&&device&&device.deviceMakeModel&&device.deviceMakeModel.isWifi">
            <span class="grey--text">Currently no linked wifi profiles.</span>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <!-- <v-btn
              class="primary white--text"
              round
              @click="addHsiProfileItem=false, item={}"
            >Cancel</v-btn> -->
            <v-btn class="primary white--text" round @click="saveHsiProfile()">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- Add Wifi Profile Modal -->

    <v-dialog v-model="addWifiProfileItem" max-width="750px" persistent>
      <v-card flat color="white">
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">{{wifiItem.type}} WIFI PROFILE</h1>
        </v-toolbar>
        <v-card-text>
          <v-layout>
            <v-flex xs6 px-1>
              <v-text-field v-model="wifiItem.ssid" label="SSID"></v-text-field>
            </v-flex>
            <v-flex xs6 px-1>
              <v-text-field v-model="wifiItem.password" label="Password"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6 px-1>
              <v-select
                v-model="wifiItem.encryption"
                label="Encryption Type"
                :items="encryptionTypes"
              ></v-select>
            </v-flex>
            <v-flex xs6 px-1>
              <v-select
                v-model="wifiItem.frequencyBand"
                label="Frequency Band"
                item-text="name"
                item-value="name"
                :items="frequencyBandTypes"
              ></v-select>
            </v-flex>
          </v-layout>
         
          <v-layout>
             <v-flex xs4 px-4>
            <v-text-field v-model="wifiItem.channel" label="Channel" type="number"></v-text-field>
          </v-flex>
            <v-flex xs3 ml-1 px-1>
              <v-switch v-model="wifiItem.enable" label="Enabled"></v-switch>
            </v-flex>
            <v-flex xs3 px-1>
              <v-switch v-model="wifiItem.hidden" label="Hidden"></v-switch>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn
              class="primary white--text"
              round
              @click="addWifiProfileItem=false, wifiItem={}"
            >Cancel</v-btn>
            <v-btn class="primary white--text" round @click="saveWifiProfile()">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Add VOIP Profile Modal -->

    <v-dialog v-model="addVoipProfileItem" max-width="750px" persistent>
      <v-card flat color="white">
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">{{item.type}} VOIP PROFILE</h1>
        </v-toolbar>
        <v-card-text>
          <v-layout>
            <v-flex xs6>
              <v-select v-model="item.line_id" label="Line ID" :items="lineProfiles"></v-select>
            </v-flex>
            <v-flex xs6>
              <v-text-field v-model="item.server" label="Server"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6>
              <v-text-field v-model="item.username" label="Username"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field v-model="item.password" label="Password"></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn
              class="primary white--text"
              round
              @click="addVoipProfileItem=false, item={}"
            >Cancel</v-btn>
            <v-btn class="primary white--text" round @click="saveVoipProfile()">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Add Bridge Modal-->

    <v-dialog v-model="addBridgeItem" max-width="750px" persistent>
      <v-card flat color="white">
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">{{item.type}} Bridge</h1>
          <v-spacer></v-spacer>
          <v-btn flat color="white" class="white--text" @click="addBridgeItem=false, item={}">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <!-- Port Info -->
          <v-layout justify-center>
            <v-flex xs12>
              <h3>Port</h3>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6>
              <v-checkbox label="Auto Select Gem Port ID" v-model="item.autoSelectGemPort"></v-checkbox>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                v-if="!item.autoSelectGemPort"
                type="number"
                :min="0"
                v-model="item.gponPortId"
                label="GEM Port ID"
              ></v-text-field>
              <v-text-field v-else disabled v-model="item.gponPortId" label="GEM Port ID"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6>
              <v-autocomplete
                v-model="item.gponTrafficIndex"
                :items="zhonetrafficprofiles"
                label="GTP Index"
                item-text="name"
                item-value="name"
              ></v-autocomplete>
            </v-flex>
          </v-layout>

          <!-- GTP Info -->

          <v-layout justify-center>
            <v-flex xs12>
              <h3>Bridge Logical</h3>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <v-autocomplete
                :items="bridgetemplates"
                v-model="item.bridgeTemplateName"
                item-text="name"
                item-value="name"
                label="Bridge Logical Template"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6 mx-1>
              <v-autocomplete
                :items="vlanArray"
                type="number"
                :min="0"
                v-model="item.vlanXlate"
                label="Vlan"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6 mx-1>
              <v-autocomplete
                v-model="item.speedProfile"
                :items="speedprofiles"
                label="Speed Profile"
                item-text="name"
                return-object
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout v-if="item.speedProfile">
            <v-flex xs6 mx-1>
              <v-text-field
                disabled
                read-only
                :placeholder="(item.speedProfile.downloadMbps*1024).toString()"
                label="Egress Group Index"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 mx-1>
              <v-text-field
                disabled
                read-only
                :placeholder="(item.speedProfile.uploadMbps*1024).toString()"
                label="Ingress Group Index"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout justify-center>
            <v-flex xs12>
              <h3>CPE Connection</h3>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6 mx-1>
              <v-autocomplete
                :items="tpTypeArray"
                item-text="name"
                item-value="id"
                v-model="item.tpType"
                label="Type"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6 mx-1>
              <v-autocomplete :items="[1,2,3,4]" v-model="item.tpIndex" label="Ethernet Port"></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6 mx-1>
              <v-autocomplete
                :items="rgModeArray"
                item-text="name"
                item-value="id"
                v-model="item.rgMode"
                label="RG Mode"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6 mx-1>
              <v-autocomplete :items="vlanArray" :min="0" v-model="item.vlan" label="Uni Vlan"></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn
              v-if="item.vlan&&item.vlanXlate&&item.tpIndex&&item.speedProfile.downloadMbps"
              class="primary white--text"
              round
              @click="saveBridgeItem()"
            >Add Connection</v-btn>
            <v-btn v-else disabled class="primary white--text" round>Add Connection</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Attach Location/Network/Node modal -->
    <v-dialog v-model="addLocationModal" persistent max-width="1200px">
      <v-card>
        <v-toolbar flat color="primary">
          <h1 class="headline white--text">FIND END LOCATION</h1>
        </v-toolbar>
        <v-toolbar flat color="white">
          <v-spacer></v-spacer>
          <v-autocomplete
            v-model="filterNetwork"
            :items="networks"
            clearable
            item-text="name"
            item-value="id"
            label="Filter By Network"
          ></v-autocomplete>
          <!-- <v-btn v-if="filterNetwork!==null&&typeof filterNetwork!=='undefined'" class="primary" round @click="filterLocations()">Filter</v-btn> -->
          <v-text-field v-model="search" label="Search"></v-text-field>
        </v-toolbar>

        <v-card-text>
          <v-data-table
            class="elevation-1"
            :items="locations"
            :search="search"
            :headers="locationHeaders"
            align-center
          >
            <template v-slot:items="props">
              <!-- <td class="text-xs-center">
                                  <v-icon color="primary" @click="updateDeviceLocation()">add_circle_outline</v-icon>
              </td>-->
              <td class="text-xs-center">
                <v-btn flat color="primary" @click="updateDeviceLocation(props.item)">
                  <v-icon>add_circle_outline</v-icon>
                </v-btn>
              </td>
              <td class="text-xs-center">{{props.item.locationDescription}}</td>
              <td class="text-xs-center">{{props.item.erfNo}}</td>
              <td class="text-xs-center">{{props.item.unitNo}}</td>
              <td class="text-xs-center">{{props.item.otherNo}}</td>
              <td
                class="text-xs-center"
                v-if="props.item.locationNetworkSubComplexId!==null"
              >{{props.item.locationNetworkSubComplex.subComplexName}}</td>
              <td v-else></td>
              <td class="text-xs-center">{{props.item.complexName}}</td>
              <td
                class="text-xs-center"
                v-if="props.item.locationNetworkId!==null"
              >{{props.item.locationNetwork.name}}</td>
              <td
                class="text-xs-center"
                v-if="props.item.locationNetworkId!==null"
              >{{props.item.locationNetwork.locationNode.name}}</td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn class="primary" round @click="addLocationModal=false">Cancel</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Add Network Modal -->
    <v-dialog v-model="addNetworkModal" persistent max-width="1200px">
      <v-card>
        <v-toolbar flat color="primary">
          <h1 class="headline white--text">FIND NETWORK</h1>
        </v-toolbar>
        <v-toolbar flat color="white">
          <v-spacer></v-spacer>
          <v-text-field v-model="searchNetwork" label="Search"></v-text-field>
        </v-toolbar>

        <v-card-text>
          <v-data-table
            class="elevation-1"
            :items="networks"
            :search="searchNetwork"
            :headers="networkHeaders"
            align-center
          >
            <template v-slot:items="props">
              <!-- <td class="text-xs-center">
                                  <v-icon color="primary" @click="updateDeviceLocation()">add_circle_outline</v-icon>
              </td>-->
              <td class="text-xs-center">
                <v-btn flat color="primary" @click="updateDeviceNetwork(props.item)">
                  <v-icon>add_circle_outline</v-icon>
                </v-btn>
              </td>
              <td class="text-xs-center">{{props.item.name}}</td>
              <td class="text-xs-center">{{props.item.town}}</td>
              <td class="text-xs-center" v-if="props.item.locationNode">{{props.item.locationNode.name}}</td>
              <td class="text-xs-center">{{props.item.networkStatus}}</td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn class="primary" round @click="addNetworkModal=false">Cancel</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Add Node Modal -->
    <v-dialog v-model="addNodeModal" persistent max-width="1200px">
      <v-card>
        <v-toolbar flat color="primary">
          <h1 class="headline white--text">FIND NODE</h1>
        </v-toolbar>
        <v-toolbar flat color="white">
          <v-spacer></v-spacer>
          <v-text-field v-model="searchNode" label="Search"></v-text-field>
        </v-toolbar>

        <v-card-text>
          <v-data-table
            class="elevation-1"
            :items="nodes"
            :search="searchNode"
            :headers="nodeHeaders"
            align-center
          >
            <template v-slot:items="props">
              <!-- <td class="text-xs-center">
                                  <v-icon color="primary" @click="updateDeviceLocation()">add_circle_outline</v-icon>
              </td>-->
              <td class="text-xs-center">
                <v-btn flat color="primary" @click="updateDeviceNode(props.item)">
                  <v-icon>add_circle_outline</v-icon>
                </v-btn>
              </td>
              <td class="text-xs-center">{{props.item.name}}</td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn class="primary" round @click="addNodeModal=false">Cancel</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Add Switching Centre Modal -->
    <v-dialog v-model="addSwitchingCentreModal" persistent max-width="1200px">
      <v-card>
        <v-toolbar flat color="primary">
          <h1 class="headline white--text">FIND SWITCHING CENTRE</h1>
        </v-toolbar>
        <v-toolbar flat color="white">
          <v-spacer></v-spacer>
          <v-text-field v-model="searchSwitchingCentre" label="Search"></v-text-field>
        </v-toolbar>

        <v-card-text>
          <v-data-table
            class="elevation-1"
            :items="switchingcentres"
            :search="searchSwitchingCentre"
            :headers="switchingCentreHeaders"
            align-center
          >
            <template v-slot:items="props">
              <!-- <td class="text-xs-center">
                                  <v-icon color="primary" @click="updateDeviceLocation()">add_circle_outline</v-icon>
              </td>-->
              <td class="text-xs-center">
                <v-btn flat color="primary" @click="updateDeviceSwitchingCentre(props.item)">
                  <v-icon>add_circle_outline</v-icon>
                </v-btn>
              </td>
              <td class="text-xs-center">{{props.item.name}}</td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn class="primary" round @click="addSwitchingCentreModal=false">Cancel</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Add Upstream Device Modal -->
    <v-dialog v-model="addUpstreamDeviceModal" persistent max-width="1200px">
      <v-card>
        <v-toolbar flat color="primary">
          <h1 class="headline white--text">FIND UPSTREAM DEVICE</h1>
        </v-toolbar>
        <v-toolbar flat color="white">
          <v-spacer></v-spacer>
          <v-text-field v-model="searchUpstreamDevices" label="Search"></v-text-field>
        </v-toolbar>

        <v-card-text>
          <v-data-table
            class="elevation-1"
            :items="upstreamdevices"
            :search="searchUpstreamDevices"
            :headers="upstreamDeviceHeaders"
            align-center
          >
            <template v-slot:items="props">
              <!-- <td class="text-xs-center">
                                  <v-icon color="primary" @click="updateDeviceLocation()">add_circle_outline</v-icon>
              </td>-->
              <td class="text-xs-center">
                <v-btn flat color="primary" @click="updateUpstreamDevice(props.item)">
                  <v-icon>add_circle_outline</v-icon>
                </v-btn>
              </td>
              <td class="text-xs-center">{{props.item.systemName}}</td>
              <td class="text-xs-center">{{props.item.ipAddress}}</td>
              <td class="text-xs-center">{{props.item.serialNumber}}</td>
              <td class="text-xs-center" v-if="props.item.deviceMakeModel">{{props.item.deviceMakeModel.name}}</td>
              <td v-else></td>
              <td class="text-xs-center" v-if="props.item.deviceMakeModel && props.item.deviceMake">{{props.item.deviceMakeModel.deviceMake.name}}</td>
              <td v-else></td>
              <td class="text-xs-center" v-if="props.item.deviceMakeModel && props.item.deviceType">{{props.item.deviceMakeModel.deviceType.name}}</td>
              <td v-else></td>
              <td
                class="text-xs-center"
                v-if="props.item.locationNetwork"
              >{{props.item.locationNetwork.name}}</td>
              <td v-else></td>
              <td
                class="text-xs-center"
                v-if="props.item.locationNode"
              >{{props.item.locationNode.name}}</td>
              <td v-else></td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn class="primary" round @click="addUpstreamDeviceModal=false">Cancel</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmWarehouseChange" persistent width="400px">
      <v-card>
        <v-card-text>
          <v-layout justify-center wrap>
            <v-flex xs10>
              <span style="color: grey; fontSize: 16px">Are you sure you want to move this device to the selected warehouse? All attached location info will be removed.</span>
            </v-flex>
            <v-flex xs12>
              <v-layout justify-center wrap>
                <v-btn round color="red" class="white--text" @click="confirmWarehouseChange=false">Cancel</v-btn>
                <v-btn round color="light-green" class="white--text" @click="processWarehouseChange()">Confirm</v-btn>

              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Api from "@/services/Api.js";
import Qrcode from "vue-qrcode";
import dateformat from "dateformat";
import axios from 'axios'
import { VueSvgGauge } from 'vue-svg-gauge'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import configData from "../../../config/config.json";
const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default {
  props: [
    "device",
    "deviceMakeModels",
    "availablegraphs",
    "apiurl",
    "apitoken",
    "deviceports",
    "hsiprofiles",
    "wifiprofiles",
    "voipprofiles",
    "speedprofiles",
    "endlocations",
    "networks",
    "nodes",
    "devicelevel",
    "upstreamdevices",
    "switchingcentres",
    "zhonebridges",
    "bridgetemplates",
    "zhonetrafficprofiles",
    "devicetickets",
    "devicecomments",
    "onustatus",
    "oltstatus",
    "acsprofiles",
    "providers",
    "loadingkey",
    "organisationbridgetemplates",
    "linkeddevices",
    "serviceAccounts"
  ],
  components: {
    Qrcode,
    VueSvgGauge,
    Loading: Loading
  },
  data() {
    return {
      confirmWarehouseChange: false,
      log:[],
      initialDevice:null,
      addBridgeConnectionModal: false,
      initialRun:true,
      online:false,
      deviceSearch: '',
      speedTestLogDialog:false,
      speedTestLog:[],
      showDownloadError:false,
      showUploadError:false,
      loader:null,
      config:null,
      keySpeed:0,
      acsDevice:false,
      uploadSpeed:0,
      downloadSpeed:0,
      visibleDownload:false,
      visibleUpload:false,
      selectedGraph: null,
      viewOpenTickets: true,
      viewClosedTickets: false,
      accessTypes: ["PPPOE", "IPOE", "VOIP"],
      ipv: ["ipv4", "ipv6"],
      encryptionTypes: ["WEP", "WPA", "WPA2", "WPA+WPA2"],
      frequencyBandTypes: [],
      lineProfiles: ["FXS1", "FXS2"],
      graphImage: null,
      selectedPort: null,
      snackbar: false,
      errorSnackbar: false,
      text: "",
      y: "top",
      portStats: null,
      comment: "",
      deviceLevel: null,
      deviceLevels: ["End Location", "Network", "Node", "Switching Centre"],
      searchNetwork: "",
      item: {},
      wifiItem: {},
      viewMore: false,
      addHsiProfileItem: false,
      addWifiProfileItem: false,
      addVoipProfileItem: false,
      availablePorts: [],
      index: -1,
      editingDevice: false,
      addLocationModal: false,
      search: "",
      searchNode: "",
      searchUpstreamDevices: "",
      locations: [],
      filterNetwork: null,
      addNodeModal: false,
      addNetworkModal: false,
      addUpstreamDeviceModal: false,
      addSwitchingCentreModal: false,
      addBridgeItem: false,
      searchSwitchingCentre: "",
      vlanArray: this.range(0, 4096),
      wifiKey: 0,
      warehouses: [],
      rgModeArray: [
        { id: 1, name: "Routed" },
        { id: 2, name: "BRouted" },
        { id: 3, name: "rPPPoE" },
        { id: 4, name: "bPPPoE" },
        { id: 5, name: "Bridged" },
        { id: 6, name: "Not Applicable" }
      ],
      tpTypeArray: [
        { id: 1, name: "Ethernet UNI" },
        { id: 2, name: "VCC Termination Point" },
        { id: 3, name: "Mapper Service Profile" },
        { id: 4, name: "IP Host Config Data" },
        { id: 5, name: "GEM Interworking Termination Point" },
        { id: 6, name: "Multicast GEM Interworking Termination Point" },
        { id: 7, name: "xDSL UNI" },
        { id: 8, name: "VDSL UNI" },
        { id: 9, name: "Ether Flow Termination Point" },
        { id: 10, name: "Physical Path UNI" },
        { id: 11, name: "Physical Path RF Video UNI" },
        { id: 12, name: "Physical Path IPTV UNI" },
        { id: 13, name: "H248 Voice" },
        { id: 14, name: "SIP Voice" },
        { id: 15, name: "SIP PLAR Voice" },
        { id: 16, name: "PWE Termination" },
        { id: 17, name: "Virtual Ethernet" },
        { id: 18, name: "dot11 Termination Point" },
        { id: 19, name: "Fiber LAN Termination Point" },
        { id: 20, name: "TR69 Termination Point" },
        { id: 21, name: "Management Termination Point" },
        { id: 22, name: "MGCP Voice Termination Point" }
      ],
      linkedDeviceHeaders: [
        {
          text: "System Name",
          align: "center",
          value: "systemName"
        },
       
        {
          text: "Model",
          align: "center",
          value: "deviceMakeModel.name"
        },
        {
          text: "IP Address",
          align: "center",
          value: "ipAddress"
        },
        {
          text: "Serial Number",
          align: "center",
          value: "serialNumber"
        },
        {
          text: "Pon Mac/ FSAN",
          align: "center",
          value: "ponMac"
        },
        {
          text: "Software Version",
          align: "center",
          value: "softwareVersion"
        },
      
        {
          text: "PON ID",
          align: "center",
          value: "ponId"
        },
        {
          text: "Frame",
          align: "center",
          value: "frame"
        },
        {
          text: "Slot",
          align: "center",
          value: "slot"
        },
        {
          text: "Port",
          align: "center",
          value: "port"
        },
        {
          text: "Note",
          align: "center",
          value: "note"
        }
      ],
      speedTestLogHeaders: [
        {
          text: "Date",
          align: "center",
          value: "createdAt"
        },
        {
          text: "Download Speed",
          align: "center",
          value: "downloadSpeed"
        },
        {
          text: "Upload Speed",
          align: "center",
          value: "uploadSpeed"
        },
      ],
      upstreamDeviceHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "System Name",
          align: "center",
          value: "systemName"
        },
        {
          text: "IP Address",
          align: "center",
          value: "ipAddress"
        },
        {
          text: "Serial Number",
          align: "center",
          value: "serialNumber"
        },
        {
          text: "Model",
          align: "center",
          value: "deviceMakeModel.name"
        },
        {
          text: "Make",
          align: "center",
          value: "deviceMakeModel.deviceMake.name"
        },
        {
          text: "Type",
          align: "center",
          value: "deviceMakeModel.deviceType.name"
        },

        {
          text: "Network",
          align: "center",
          value: "locationNetwork.name"
        },
        {
          text: "Node",
          align: "center",
          value: "locationNode.name"
        }
      ],
      switchingCentreHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        }
      ],
      nodeHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        }
      ],
      networkHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Town",
          align: "center",
          value: "town"
        },
        {
          text: "Node",
          align: "center",
          value: "locationNode.name"
        },
        {
          text: "Status",
          align: "center",
          value: "networkStatus"
        }
      ],
      locationHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Description",
          align: "center",
          value: "locationDescription"
        },
        {
          text: "Erf No",
          align: "center",
          value: "erfNo"
        },
        {
          text: "Unit No",
          align: "center",
          value: "unit"
        },
        {
          text: "Other No",
          align: "center",
          value: "otherNo"
        },
        {
          text: "Subcomplex Name",
          align: "center",
          value: "locationNetworkSubComplex.subComplexName"
        },
        {
          text: "Complex Name",
          align: "center",
          value: "complexName"
        },
        {
          text: "Network",
          align: "center",
          value: "locationNetwork.name"
        },
        {
          text: "Node",
          align: "center",
          value: "locationNetwork.locationNode.name"
        }
      ]
    };
  },
  watch: {
    filterNetwork(value) {
      if (value !== null && typeof value !== "undefined") {
        this.filterLocations();
      } else {
        this.locations = this.endlocations;
      }
    },
    onustatus(value){
      if(value.isOnline===true){
         this.online =true
      }
    }
  },
  created(){
     this.getInitialDevice()
     this.getWarehouses()
  },
  mounted() {   
    this.deviceLevel = this.devicelevel;
    this.config = configData;
    // this.fetchSpeedTestLog()
  },
  async beforeDestroy(){
    source.cancel('Operation canceled by the user.');
  },
  methods: {
    getWarehouses(){
      Api().get('/stockWarehouse').then(res=>{
        this.warehouses = res.data
      })
    },
    getInitialDevice(){
Api().get('/devices/'+ this.$route.params.deviceId).then(response=>{
  this.initialDevice = response.data
  this.initialDevice.devicelevel=this.devicelevel
})
    },
    logChange(variable, subVariable, name, value, type){
      if(subVariable){
   if(this.initialDevice[variable][subVariable] != value && this.log.filter(x=>x.name ==name).length==0){
            this.log.push({name: name, 
                          initialValue: this.initialDevice[variable][subVariable], 
                          value: value, 
                          type: type})
         }else if(this.initialDevice[variable][subVariable] != value && this.log.filter(x=>x.name ==name).length>0){
            let found = this.log.filter(x=>x.name ==name)
            let index = this.log.indexOf(found[0]);
            this.log[index].value= value
         }
         else if(this.initialDevice[variable][subVariable] == value && this.log.filter(x=>x.name ==name).length>0){
            let found = this.log.filter(x=>x.name ==name)
            let index = this.log.indexOf(found[0]);
            this.log.splice(index, 1);
            }

      }else{
         if(this.initialDevice[variable] != value && this.log.filter(x=>x.name ==name).length==0){
            this.log.push({name: name, 
                          initialValue: this.initialDevice[variable], 
                          value: value, 
                          type: type})
         }else if(this.initialDevice[variable] != value && this.log.filter(x=>x.name ==name).length>0){
            let found = this.log.filter(x=>x.name ==name)
            let index = this.log.indexOf(found[0]);
            this.log[index].value= value
         }
         else if(this.initialDevice[variable] == value && this.log.filter(x=>x.name ==name).length>0){
            let found = this.log.filter(x=>x.name ==name)
            let index = this.log.indexOf(found[0]);
            this.log.splice(index, 1);
            }
      }
    },
    async saveLogChange(){
      if(this.log.length>0){
         let post =[]
      for (let i=0; i< this.log.length;i++){
        await post.push({
        data: this.$store.state.user.name + ' ' + this.$store.state.user.surname + ' ' + 
        this.log[i].type + ' the ' + this.log[i].name + ' from ' + this.log[i].initialValue 
        + ' to ' + this.log[i].value + '.',
        deviceId: this.$route.params.deviceId,
        organisationId: this.$store.state.currentOrg.org.id,
        isActive: true,
        isDeleted: false
        })}

        Api().post('/changeLogs', {
        batch: post
      }).then(response=>{
        this.getInitialDevice()
      })
      }
      },    
    async routeToTicketSummary(item) {
      let url = item;
      let route = await this.$store.state.currentOrg.org.permissions.filter(
        function (el) {
          return el.url === "/ticketSummary/:ticketId";
        }
      );
      await this.$store.dispatch("setCurrentRoute", route[0]);
      this.$router.push({ path: "/ticketSummary/" + item });
    },
    async routeToServiceAccountSummary(item) {
      let url = item;
      let route = await this.$store.state.currentOrg.org.permissions.filter(
        function (el) {
          return el.url === "/serviceAccounts/:serviceAccountId";
        }
      );
      await this.$store.dispatch("setCurrentRoute", route[0]);
      this.$router.push({ path: "/serviceAccounts/" + item });
    },
    viewDeviceDetails(item) {
      this.$router.push({ path: "/devices/" + item.id });
    },
    fetchSpeedTestLog(){
     Api().get('/speedTestLog/byDevice/' + this.$route.params.deviceId).then(response=>{
       this.speedTestLog = response.data
     })
    },
    range(start, end) {
      return Array(end - start + 1)
        .fill()
        .map((_, idx) => start + idx);
    },
    updateUpstreamDevice(item) {
      if (
        item.locationNetworkId !== this.device.locationNetworkId &&
        item.locationNodeId !== this.device.locationNodeId
      ) {
        confirm(
          "The location of this upstream device does not match with the current location, do you want to continue? WARNING: This will update the location of the current downstream device."
        ) &&
          Api()
            .put("/devices/" + this.$route.params.deviceId, {
              locationId: null,
              locationNetworkId: item.locationNetworkId,
              locationNodeId: item.locationNodeId,
              upstreamDeviceId: item.id
            })
            .then(response => {
              this.device.locationId = null;
              this.device.locationNetworkId = item.locationNetworkId;
              this.device.locationNodeId = item.locationNodeId;
              this.device.locationNetwork = item.locationNetwork;
              this.device.locationNode = item.locationNode;
              this.device.upstreamDevice = item
              this.device.upstreamDeviceId = item.id;
              this.device.upstreamDevice.deviceMakeModel.name = item.deviceMakeModel.name
              this.device.upstreamDevice.ipAddress = item.ipAddress
              this.snackbar = true;
              this.text = "Upstream Device Successfully Updated!";
              this.addUpstreamDeviceModal = false;
              this.logChange('upstreamDevice','systemName', 'Upstream Device', item.systemName, 'updated')
            });
      } else {
        Api()
          .put("/devices/" + this.$route.params.deviceId, {
            upstreamDeviceId: item.id
          })
          .then(response => {
            this.device.upstreamDeviceId = item.id;
            this.device.upstreamDevice = item;
             this.device.upstreamDevice.deviceMakeModel.name = item.deviceMakeModel.name
              this.device.upstreamDevice.ipAddress = item.ipAddress
            this.snackbar = true;
            this.text = "Upstream Device Successfully Updated!";
            this.addUpstreamDeviceModal = false;
            this.logChange('upstreamDevice','systemName','Upstream Device', item.systemName, 'updated')
          });
      }
      
    },
    addUpstreamDeviceItem() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        if (this.upstreamdevices.length > 0) {
          this.addUpstreamDeviceModal = true;

        } else {
          confirm(
            "No Upstream Device Type found for " +
              this.device.deviceMakeModel.deviceType.name +
              ". Please attach an upstream device type under the device type settings."
          );
        }
      }
    },
    async filterLocations() {
      if (
        typeof this.filterNetwork !== "undefined" &&
        this.filterNetwork !== null
      ) {
        let id = this.filterNetwork;
        this.locations = await this.endlocations.filter(function(el) {
          return el.locationNetworkId === id;
        });
      } else {
        this.locations = this.endlocations;
      }
    },
    updateDeviceNode(item) {
      Api()
        .put("/devices/" + this.$route.params.deviceId, {
          locationId: null,
          locationNetworkId: null,
          locationNodeId: item.id
        })
        .then(response => {
          this.device.locationId = null;
          this.device.locationNetworkId = null;
          this.device.locationNodeId = item.id;
          this.device.locationNode = item;
          this.addNodeModal = false;
          this.logChange('locationNode','name', 'Location Node', item.name, 'updated')
        });
    },
    updateDeviceSwitchingCentre(item) {
      Api()
        .put("/devices/" + this.$route.params.deviceId, {
          locationId: null,
          locationNetworkId: null,
          locationNodeId: null,
          switchingCentreId: item.id
        })
        .then(response => {
          this.device.locationId = null;
          this.device.locationNetworkId = null;
          this.device.locationNodeId = null;
          this.device.locationNode = null;
          this.device.switchingCentreId = item.id;
          this.device.switchingCentre = item;
          this.logChange('switchingCentre','name', 'Switching Centre', item.name, 'updated')
        });
    },
    updateDeviceNetwork(item) {
      Api()
        .put("/devices/" + this.$route.params.deviceId, {
          locationId: null,
          locationNetworkId: item.id,
          locationNodeId: item.locationNodeId
        })
        .then(response => {
          this.device.locationId = null;
          this.device.locationNetworkId = item.id;
          this.device.locationNodeId = item.locationNodeId;
          this.device.locationNetwork = item;
          this.device.locationNode = item.locationNode;
          this.addNetworkModal = false;
          this.logChange('locationNetwork','name', 'Location Network', item.name, 'updated')

        });
    },
    updateDeviceLocation(item) {
      Api()
        .put("/devices/" + this.$route.params.deviceId, {
          locationId: item.id,
          locationNetworkId: item.locationNetworkId,
          locationNodeId: item.locationNetwork.locationNodeId
        })
        .then(response => {
          Api().put("/locations/" + item.id, {
            equipmentInstalled: true,
            fibrePulled: true
          });
          this.device.locationId = item.id;
          this.device.locationNetworkId = item.locationNetworkId;
          this.device.locationNodeId = item.locationNetwork.locationNodeId;
          this.device.location = item;
          this.device.locationNetwork = item.locationNetwork;
          this.device.locationNode = item.locationNetwork.locationNode;
          this.addLocationModal = false;
          this.logChange('location','locationDescription', 'End Location', item.locationDescription, 'updated')
        });
    },
    editLocation() {
      this.addLocationModal = true;
    },
    editNetwork() {
      this.addNetworkModal = true;
    },
    editNode() {
      this.addNodeModal = true;
    },
    editSwitchingCentre() {
      this.addSwitchingCentreModal = true;
    },
    addLocationItem() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.addLocationModal = true;
      }
    },
    addNetworkItem() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.addNetworkModal = true;
      }
    },
    addNodeItem() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.addNodeModal = true;
      }
    },
    addSwitchingCentreItem() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.addSwitchingCentreModal = true;
      }
    },
    editDeviceInfoItem() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.editingDevice = !this.editingDevice;
        this.locations = this.endlocations;
      }
    },
    saveBridgeItem() {
      let obj = {};
      if (this.item.autoSelectGemPort) {
        obj.autoSelectGemPortValue = 1;
      } else {
        obj.autoSelectGemPortValue = 2;
      }
      obj.rgMode = this.item.rgMode;
      obj.Device_ID = this.device.Device_ID;
      obj.vlan = this.item.vlan;
      obj.vlanXlate = this.item.vlanXlate;
      obj.bridgeTemplateName = this.item.bridgeTemplateName;
      obj.downloadSpeed = this.item.speedProfile.downloadMbps;
      obj.uploadSpeed = this.item.speedProfile.uploadMbps;
      obj.tpType = this.item.tpType;
      obj.tpIndex = this.item.tpIndex;
      obj.gponSlotId = this.device.gponSlotId;
      obj.gponOltId = this.device.gponOltId;
      obj.gponOnuId = this.device.gponOnuId;
      obj.gponPortId = this.item.gponPortId;
      obj.gponTrafficIndex = this.item.gponTrafficIndex;
      Api().post("/aps/zhone/configureOnu", obj);
    },

    deleteBridgeItem(item) {
      confirm("Are you sure you would like to remove this connection?") &&
        Api()
          .post("/zhone/deleteOmciProfile/" + item.connectionId + "/" + item.id, {
          cancelToken: source.token
        })
          .then(response => {
            if(response.data&&response.data.id&&response.data.isDeleted){
              let index = this.zhonebridges.indexOf(item);
                  this.zhonebridges.splice(index, 1);
                  this.text = "Successfully removed connection!";
                  this.snackbar = true;
            }
            // if (
            //   response.data[0].status[0] == "Success" ||
            //   response.data[0].Description[0] == "OBJECT_DOES_NOT_EXISTS"
            // ) {
            //   Api()
            //     .put("/deviceBridge/" + item.id, {
            //       isActive: false,
            //       isDeleted: true
            //     })
            //     .then(response => {
            //       let index = this.zhonebridges.indexOf(item);
            //       this.zhonebridges.splice(index, 1);
            //       this.text = "Successfully removed connection!";
            //       this.snackbar = true;
            //     });
            // }
          });
    },

    addComment() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        Api()
          .post("/deviceComments", {
            deviceId: this.$route.params.deviceId,
            comments: this.comment
          })
          .then(response => {
            this.comment = "";
            response.data.contact = this.$store.state.user;
            this.devicecomments.push(response.data);
          });
      }
    },
    saveDeviceInfoChanges() {
      this.editingDevice = false;
      let locationId = null;
      let locationNetworkId = null;
      let locationNodeId = null;
      let switchingCentreId = null;
      if (this.devicelevel === "End Location") {
        locationId = this.device.locationId;
        locationNetworkId = this.device.locationNetworkId;
        locationNodeId = this.device.locationNodeId;
        switchingCentreId = this.device.switchingCentreId;
      } else if (this.devicelevel === "Network") {
        locationId = null;
        locationNetworkId = this.device.locationNetworkId;
        locationNodeId = this.device.locationNodeId;
        switchingCentreId = this.device.switchingCentreId;
      } else if (this.devicelevel === "Node") {
        locationId = null;
        locationNetworkId = null;
        locationNodeId = this.device.locationNodeId;
        switchingCentreId = this.device.switchingCentreId;
      } else if (this.devicelevel === "Switching Centre") {
        locationId = null;
        locationNetworkId = null;
        locationNodeId = null;
        switchingCentreId = this.device.switchingCentreId;
      }

      Api()
        .put("/devices/" + this.$route.params.deviceId, {
          systemName: this.device.systemName,
          ponMac: this.device.ponMac,
          serialNumber: this.device.serialNumber,
          ipAddress: this.device.ipAddress,
          locationId: locationId,
          locationNetworkId: locationNetworkId,
          locationNodeId: locationNodeId,
          switchingCentreId: switchingCentreId
        })
        .then(response => {
          this.saveLogChange()
          this.snackbar = true;
          this.text = "Device Info Successfully Saved!";
        });
    },
    async updateShareStatus(device){
      await Api().put('/devices/'+device.id, {shareDeviceStatus: device.shareDeviceStatus})
    },
    async createBridgeTicket(item){
      let obj = {
        
        downstreamTrafficProfile: item.speedProfile? item.speedProfile.downloadMbps.toString()+'Mbps': null,
        upstreamTrafficProfile: item.speedProfile? item.speedProfile.uploadMbps.toString()+'Mbps': null,
        deviceName: this.device.upstreamDevice.systemName,
        frameId: this.device.frame,
        slotId: this.device.slot,
        portId: this.device.port,
        onuId: this.device.ponId,
        tagTransform: item.organisationBridgeTemplate.translationType,
        outerVlan: item.organisationBridgeTemplate.outerVlan,
        userVlan: item.organisationBridgeTemplate.innerVlan
      }
      await Api().post('/createDeviceBridge', obj).then(res=>{

      })
    },
    async deleteHsiProfileItem(item) {
      if (this.authDelete(this.$store.state.currentRoute)) {
        confirm(
          "Are you sure you want to remove this HSI Profile from this device?"
        ) &&
          Api()
            .post("/acs/removeHsi/auto", {
              deviceBridgeId: item.id,
              ponMac: this.device.ponMac,
              customerOrganisationId: item.customerOrganisationId
            })
            .then(response => {
              if (response.status == 200) {
                // Api()
                //   .put("/deviceBridge/" + item.id, {
                //     isActive: true,
                //     isDeleted: false
                //   })
                //   .then(response => {
                    this.acsprofiles.splice(this.acsprofiles.indexOf(item), 1);
                    this.text = "Successfully removed connection!";
                    this.snackbar = true;
                  // });
              }
            });
      }
    },
    async removeU2000Bridge(item){
      if(this.authAdmin(this.$store.state.currentRoute)){
        let description = {
        deviceBridgeId: item.id,
        deviceName: this.device.upstreamDevice.systemName,
        frameId: this.device.frame,
        slotId: this.device.slot,
        portId: this.device.port,
        onuId: this.device.ponId,
        gemportId: item.gemportId
      }
      let obj = {
        currentStatus: 'Pending',
        importance: 'Average',
        isComplete: false,
        dueDate: new Date(),
        dueTime: "00:00:00",
        organisationId: this.$store.state.currentOrg.org.id,
        deviceId: this.device.id,
        ticketCategoryItemId: 26,
        description: JSON.stringify(description),
        isSystemGenerated: true,
        isActive: true,
        isDeleted: false
      }
      await Api().post('/ticket', obj).then(res=>{
        this.$emot('refreshTickets')
      })
      }
      
    },
    async editHsiProfileItem(item) {
      if(this.device.deviceMakeModel.twoGhzWifi){
        this.frequencyBandTypes.push({name: '2.4'})
      }
      if(this.device.deviceMakeModel.fiveGhzWifi){
        this.frequencyBandTypes.push({name: '5'})
      }

      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.index = await this.acsprofiles.indexOf(item);
        let availablePorts = ["port_1", "port_2", "port_3", "port_4"];
        let usedPorts = [];
        let itemIndex = this.acsprofiles.indexOf(item);
        for (let i = 0; i < this.acsprofiles.length; i++) {
          if (i !== itemIndex) {
            if (this.acsprofiles[i].port_1) {
              if (!usedPorts.includes("port_1")) {
                await usedPorts.push("port_1");
              }
            }
            if (this.acsprofiles[i].port_2) {
              if (!usedPorts.includes("port_2")) {
                await usedPorts.push("port_2");
              }
            }
            if (this.acsprofiles[i].port_3) {
              if (!usedPorts.includes("port_3")) {
                await usedPorts.push("port_3");
              }
            }
            if (this.acsprofiles[i].port_4) {
              if (!usedPorts.includes("port_4")) {
                await usedPorts.push("port_4");
              }
            }
          }
        }
        for (let a = 0; a < usedPorts.length; a++) {
          let index = availablePorts.indexOf(usedPorts[a]);
          availablePorts.splice(index, 1);
        }
        this.availablePorts = availablePorts;
        this.item = {
          id: item.id,
          type: "EDIT",
          access_type: item.access_type,
          username: item.username,
          password: item.password,
          downstreamRate: item.downstreamRate,
          upstreamRate: item.upstreamRate,
          // speedProfileId: item.speedProfileId,
          // speedProfile: item.speedProfile,
          vlan: item.vlan,
          port_1: item.port_1,
          port_2: item.port_2,
          port_3: item.port_3,
          port_4: item.port_4,
          ipv4or6: item.ipv4or6,
          wanStaticIp: item.wanStaticIp,
          wanSubnet: item.wanSubnet,
          wanDefaultGateway: item.wanDefaultGateway,
          deviceWifis: item.deviceWifis.filter(x => x.isActive) || [],
          customerOrganisationId: item.customerOrganisationId
        };
        this.addHsiProfileItem = true;
      }
    },
    async addBridgeModal() {
      if (this.authCreate(this.$store.state.currentRoute)) {
        this.item = {
          type: "Add",
          autoSelectGemPort: false,
          vlan: 0,
          vlanXlate: 0,
          tpType: 1,
          tpIndex: 1,
          egressGroupIndex: 0,
          groupIndex: 0,
          rgMode: 6,
          bridgeTemplateId: null,
          gponPortId: 0,
          gponTrafficIndex: "1100000000",
          bridgeTemplateName: "DownlinkSingleTagged"
        };
        this.addBridgeItem = true;
      }
    },

    async addBridgeConnection(){
      if(this.authCreate(this.$store.state.currentRoute)){
        this.item = {
          organisationBridgeTemplate: null
        };
        this.addBridgeConnectionModal = true
      }
      

    },

    async addHsiProfileModal() {
    if(this.device.deviceMakeModel.twoGhzWifi){
        this.frequencyBandTypes.push({name: 2.4})
      }
      if(this.device.deviceMakeModel.fiveGhzWifi){
        this.frequencyBandTypes.push({name: 5})
      }

      
      
      if (this.authCreate(this.$store.state.currentRoute)) {
        let availablePorts = [
          "port_1",
          "port_2",
          "port_3",
          "port_4",
        ];
        let usedPorts = [];
        for (let i = 0; i < this.acsprofiles.length; i++) {
          if (this.acsprofiles[i].port_1) {
            if (!usedPorts.includes("port_1")) {
              await usedPorts.push("port_1");
            }
          }
          if (this.acsprofiles[i].port_2) {
            if (!usedPorts.includes("port_2")) {
              await usedPorts.push("port_2");
            }
          }
          if (this.acsprofiles[i].port_3) {
            if (!usedPorts.includes("port_3")) {
              await usedPorts.push("port_3");
            }
          }
          if (this.acsprofiles[i].port_4) {
            if (!usedPorts.includes("port_4")) {
              await usedPorts.push("port_4");
            }
          }
        }
        
        for (let a = 0; a < usedPorts.length; a++) {
          let index = availablePorts.indexOf(usedPorts[a]);
          availablePorts.splice(index, 1);
        }
        this.availablePorts = availablePorts;
        this.item = {
          type: "ADD",
          access_type: null,
          username: "",
          password: "",
          downstreamRate: 0,
          upstreamRate: 0,
          vlan: 0,
          speedProfileId: null,
          port_1: false,
          port_2: false,
          port_3: false,
          port_4: false,
          ipv4or6: "",
          wanStaticIp: "",
          wanSubnet: "",
          wanDefaultGateway: ""
        };
        this.addHsiProfileItem = true;
      }
    },
    formatDateTime(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd HH:MM");
      } else {
        null;
      }
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd");
      } else {
        null;
      }
    },
    addWifiProfileModal(hsi) {
      if (this.authCreate(this.$store.state.currentRoute)) {
        this.wifiItem = {
          type: "ADD",
          ssid: "",
          password: "",
          channel: 0,
          encryption: "WPA2",
          enable: false,
          hidden: false,
          frequencyBand: "2.4",
          deviceBridgeId: hsi.id,
          customerOrganisationId: hsi.customerOrganisationId
        };
        this.addWifiProfileItem = true;
      }
    },
    editWifiProfileItem(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        if(this.device.deviceMakeModel.twoGhzWifi){
        this.frequencyBandTypes.push({name: '2.4'})
      }
      if(this.device.deviceMakeModel.fiveGhzWifi){
        this.frequencyBandTypes.push({name: '5'})
      }
      this.wifiItem = item
      this.wifiItem.acsId = this.device.acsId
      this.wifiItem.type = 'EDIT'
        this.addWifiProfileItem = true;
      }
    },
    async deleteWifiProfileItem(item) {
      if (this.authDelete(this.$store.state.currentRoute)) {
        confirm(
          "Are you sure you want to remove this Wifi Profile from this device?"
        ) &&
          Api()
            .post("/ticket", {
             currentStatus: 'Pending',
          importance: 'Average',
          isComplete: false,
          ticketCategoryItemId: 7,
          organisationId: this.$store.state.currentOrg.org.id,
          serviceAccountId: item.serviceAccountId,
          deviceId: item.deviceId,
          dueDate: new Date(),
          dueTime: [new Date().getHours(),new Date().getMinutes(),new Date().getSeconds()].join(':'),
          createdById: this.$store.state.user.id,
          description: JSON.stringify(item),
          isSystemGenerated: true,
          isActive: true,
          isDeleted: false
            })
            .then(response => {
              this.$emit("refreshWifiConnections")
            });
      }
    },
    addVoipProfileModal() {
      if (this.authCreate(this.$store.state.currentRoute)) {
        this.item = {
          type: "ADD",
          line_id: "",
          username: "",
          password: "",
          server: ""
        };
        this.addVoipProfileItem = true;
      }
    },
    editVoipProfileItem(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.index = this.voipprofiles.indexOf(item);
        this.item = {
          type: "EDIT",
          id: item.id,
          line_id: item.line_id,
          username: item.username,
          password: item.password,
          server: item.server
        };
        this.addVoipProfileItem = true;
      }
    },
    async deleteVoipProfileItem(item) {
      if (this.authDelete(this.$store.state.currentRoute)) {
        confirm(
          "Are you sure you want to remove this VOIP Profile from this device?"
        ) &&
          Api()
            .put("/deviceVoip/" + item.id, {
              isActive: false,
              isdeleted: true
            })
            .then(response => {
              let index = this.voipprofiles.indexOf(item);
              this.voipprofiles.splice(index, 1);
            });
      }
    },
    routeToTicket(ticket){
      this.$router.push({path: '/ticketSummary/'+ticket.id})
    },
    getGraph() {
      Api()
        .get("/libre/deviceGraph", {
          params: {
            apiUrl: this.apiurl,
            apiToken: this.apitoken,
            ipAddress: this.device.ipAddress,
            graphType: this.selectedGraph
          }
        })
        .then(response => {
          //   this.graphImage='data:image/png;base64,'+response.data
          this.graphImage = response.data;
        });
    },
    testSpeed(){
            this.initialRun=false
            this.visibleDownload = true                
          Api().get('/acs/speedTest/download/'+ this.device.ponMac+'/'+ this.device.id).then(response=>{
           if(response.data==='Timeout'){
             this.showDownloadError = true
           }
            this.downloadSpeed = response.data.downloadSpeed
            if(response.data.message==='OK'){
            this.visibleDownload = false 
            if(response.data.downloadSpeed===null){
              this.showDownloadError = true
            }else{
              this.showDownloadError = false
            }
            }else{
              this.downloadSpeed = 0
              this.showDownloadError = true
              this.visibleDownload = false 
            }
            this.visibleUpload=true
            //this.loader.hide()
                             
          Api().get('/acs/speedTest/upload/'+ this.device.ponMac+'/'+ this.device.id).then(response=>{
            if(response.data==='Timeout'){
             this.showUploadError = true
           }
            this.uploadSpeed = response.data.uploadSpeed
            if(response.data.message==='OK'){
            this.visibleUpload = false 
            if(response.data.uploadSpeed===null){
              this.showUploadError = true
            }else{
              this.showUploadError = false
            }
            }else{
              this.uploadSpeed = 0
              this.showUploadError = true
              this.visibleUpload = false
            }
          })
          })
    },
    getPortStats() {
      Api()
        .get("/libre/devicePorts/port", {
          params: {
            apiUrl: this.apiurl,
            apiToken: this.apitoken,
            ipAddress: this.device.ipAddress,
            ifName: this.selectedPort
          }
        })
        .then(response => {
          this.portStats = response.data;
        });
    },
    changeHsiViewStatus(item) {
      let index = this.hsiprofiles.indexOf(item);
      this.hsiprofiles[index].viewMore = !this.hsiprofiles[index].viewMore;
    },
    changeWifiViewStatus(item) {
      let index = this.wifiprofiles.indexOf(item);
      this.wifiprofiles[index].viewMore = !this.wifiprofiles[index].viewMore;
    },
    changeVoipViewStatus(item) {
      let index = this.voipprofiles.indexOf(item);
      this.voipprofiles[index].viewMore = !this.voipprofiles[index].viewMore;
    },
    async saveHsiProfile() {
      // if (this.item.type === "ADD") {
      //   this.item.deviceId = this.$route.params.deviceId
      //   this.item.ponMac = this.device.ponMac
      //   this.item.ponMac = this.device.ponMac
      //   Api()
      //     .post("/acs/createHsi", this.item)
      //     .then(response => {
      //      this.$emit('refreshAcsBridges')
      //       this.item = {};
      //       this.addHsiProfileItem = false;
      //     });
      // } else if (this.item.type === "EDIT") {
      //   this.item.ponMac = this.device.ponMac
      //   this.item.deviceBridgeId = this.item.id
      //   Api()
      //     .put("/acs/updateHsi", this.item)
      //     .then(response => {
      //       if(response.status === 200){
      //       this.$emit('refreshAcsBridges')
      //       }
      //       this.item = {};
      //       this.addHsiProfileItem = false;
      //     });
      // }
    },
    async saveWifiProfile() {
      
      if (this.wifiItem.type === "ADD") {
        await Api()
            .post("/ticket", {
             currentStatus: 'Pending',
          importance: 'Average',
          isComplete: false,
          ticketCategoryItemId: 6,
          organisationId: this.$store.state.currentOrg.org.id,
          serviceAccountId: this.wifiItem.serviceAccountId,
          deviceId: this.wifiItem.deviceId,
          dueDate: new Date(),
          dueTime: [new Date().getHours(),new Date().getMinutes(),new Date().getSeconds()].join(':'),
          createdById: this.$store.state.user.id,
          description: JSON.stringify(this.wifiItem),
          isSystemGenerated: true,
          isActive: true,
          isDeleted: false
            })
            .then(response => {
              this.$emit("refreshWifiConnections")
              this.wifiItem = {}
              this.addWifiProfileModal = false
            });
      } else if (this.wifiItem.type === "EDIT") {
          await Api()
            .post("/ticket", {
             currentStatus: 'Pending',
          importance: 'Average',
          isComplete: false,
          ticketCategoryItemId: 6,
          organisationId: this.$store.state.currentOrg.org.id,
          serviceAccountId: this.wifiItem.serviceAccountId,
          deviceId: this.wifiItem.deviceId,
          dueDate: new Date(),
          dueTime: [new Date().getHours(),new Date().getMinutes(),new Date().getSeconds()].join(':'),
          createdById: this.$store.state.user.id,
          description: JSON.stringify(this.wifiItem),
          isSystemGenerated: true,
          isActive: true,
          isDeleted: false
            })
            .then(response => {
              this.$emit("refreshWifiConnections")
              this.wifiItem = {}
              this.addWifiProfileItem = false
            });
      }
    },
    validateWarehouseChange(){
      this.confirmWarehouseChange = true

    },
    processWarehouseChange(){
      this.device.locationId = null
      this.device.locationNetworkId = null
      this.device.locationNodeId = null
      this.device.switchingCentreId = null
      this.device.inStock = true
      Api().put('/devices/'+this.device.id, this.device).then(res=>{
        this.confirmWarehouseChange=false
      })
    },
    saveVoipProfile() {
      if (this.item.type === "ADD") {
        Api()
          .post("/deviceVoip", {
            line_id: this.item.line_id,
            username: this.item.username,
            password: this.item.password,
            server: this.item.server,
            deviceId: this.$route.params.deviceId,
            isActive: true,
            isDeleted: false
          })
          .then(response => {
            response.data.viewMore = false;
            this.voipprofiles.push(response.data);
            this.item = {};
            this.addVoipProfileItem = false;
          });
      } else if (this.item.type === "EDIT") {
        Api()
          .put("/deviceVoip/" + this.item.id, {
            line_id: this.item.line_id,
            username: this.item.username,
            password: this.item.password,
            server: this.item.server,
            deviceId: this.$route.params.deviceId,
            isActive: true,
            isDeleted: false
          })
          .then(response => {
            response.data.viewMore = false;
            this.item = response.data;
            this.voipprofiles[this.index] = this.item;
            this.item = {};
            this.addVoipProfileItem = false;
          });
      }
    }
    //   buildBridges(){
    //       Api()
    //       .post('/huaweiOlt/buildBridges')
    //       .then(response=>{

    //       })
    //   }
    //       downloadFile(file){
    //       let file = Buffer.from(response.data.base64, 'base64')
    //       const linkSource = `data:${response.data.type};base64,${response.data.base64}`;
    //     const downloadLink = document.createElement("a");
    //     const fileName = response.data.name;

    //     downloadLink.href = linkSource;
    //     downloadLink.download = fileName;
    //     downloadLink.click();
    // },
  }
};
</script>
<style>
.pointer {
  cursor: pointer;
}
.word-break {
  -ms-word-break: break-all;
  word-break: break-all;
  word-break: break-word;
}
</style>